/* Consent-Helper (Q4 R6): cb nur bei Analytics-Einwilligung; fehlt die Privacy-API noch, auf sie warten (loadFeatures); sonst verwerfen (kein Puffer, kein gtag('consent')). */
if (typeof window.riwiAnalyticsOk !== 'function') window.riwiAnalyticsOk = function (cb) {
  function run() { try { cb(); } catch (e) { /* Messung darf nie stoeren */ } }
  var S = window.Shopify;
  if (!S) return;
  if (S.customerPrivacy && typeof S.customerPrivacy.analyticsProcessingAllowed === 'function') {
    if (S.customerPrivacy.analyticsProcessingAllowed() === true) run();
    return;
  }
  if (typeof S.loadFeatures === 'function') {
    S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!err && cp && cp.analyticsProcessingAllowed() === true) run();
    });
  }
};
/* RIWI US Landingpage v2 — behaviour for all LP sections. Single IIFE, defensive, loaded with defer. */
(function () {
  'use strict';

  if (window.__riwiLp2Init) return;
  window.__riwiLp2Init = true;

  var ready = function (fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  };

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var reduceMotion = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  /* ------------------------------------------------------------------- Warenkorb-Weg (EINE Stelle)
     Jeder Kaufpfad dieser LP, der mehr als das native Formular braucht (Gratis-Set, Gratis-Bag,
     Zubehoer-Add-ons, Storage-Bundle), faehrt dieselbe Abfolge:
       1. POST cart/add.js mit ALLEN Positionen in EINEM Aufruf
       2. GET cart.js - die BEREITS gesetzten Codes lesen. Zwingend: die add.js-Antwort ist ein
          Line-Item-Objekt und fuehrt KEIN `discount_codes` (F4, 17.09.2026).
       3. POST cart/update.js mit den ZUSAMMENGEFUEHRTEN Codes - update.js ersetzt die Codeliste
          komplett, vorhandene Codes muessen also mit, sonst geht ein bereits gesetzter Code
          (z. B. STORE20 aus dem Storage-Popup oder FREE12-XXL/FREEBAG-24) still verloren
       4. Antwort pruefen: ist der Leitcode `applicable`? -> Warenkorb. Sonst ueber die
          /discount/-Route, damit der Code wenigstens als Cookie bis in den Checkout kommt.
     Laesst sich Schritt 2 nicht lesen (Drosselung 429/430, Netz), wird Schritt 3 AUSGELASSEN -
     lieber kein neuer Rabatt als ein still geloeschter bestehender.
     Navigiert wird AUSSCHLIESSLICH nach einer Antwort, nie nach einem Timer: eine Navigation
     waehrend eines laufenden add.js bricht den Aufruf ab und der Warenkorb bleibt leer.
     JEDE Route laeuft durch Shopify.routes.root - riwi-buildit.us fuehrt neben dem US-Markt
     (USD) Kanada unter /en-ca/ und /fr-ca/ in CAD; eine unpraefixierte Route kippt den
     Warenkorb eines kanadischen Kunden auf USD.
     dropIfCodeFails: Positionen, die NUR wegen ihres Gratis-Codes im Korb liegen. Greift der
     Code nicht, werden sie wieder entfernt - nie eine Gratis-Zusage kassieren, die der
     Warenkorb nicht gewaehrt. */
  var Cart = (function () {
    function root() {
      var r = String((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
      return r.charAt(r.length - 1) === '/' ? r : r + '/';
    }
    function url(path) { return root() + String(path).replace(/^\/+/, ''); }
    function cartHref() { return root() + 'cart'; }
    function discountRoute(code) {
      return url('discount/' + encodeURIComponent(code)) + '?redirect=' + root() + 'cart';
    }
    /* riwi-us-cart-redesign P2 (16.09.2026): der "Erfolg -> /cart"-Schritt selbst, aus
       addAndApply herausgezogen, weil er ZWEIMAL vorkommt (kein Code / Leitcode applicable).
       Ist der RIWI-Drawer aktiv (setting-gated), oeffnet er statt der Navigation — die
       Seite bleibt stehen, also MUSS der aufrufende Button seinen busy/disabled-Zustand
       selbst zuruecknehmen (kein pageshow mehr, weil kein Seitenwechsel mehr stattfindet).
       Dafuer ruft jeder Aufrufer sein eigenes opts.onSuccess (Reset-Funktion) auf, bevor
       navigiert bzw. geoeffnet wird. discountRoute() (Codes greifen nicht) bleibt UNVERAENDERT
       eine echte Navigation — nur eine volle Seitenladung setzt den /discount/-Cookie. */
    /* Button-System v2 (Owner 30.09.2026): Der Warenkorb HAT die Antwort bereits bestaetigt,
       wenn wir hier ankommen. Erst dann zeigt der Kaufbutton, der gerade laedt (aria-busy +
       data-rb-atc), ~300 ms das gruene "Added" - danach dieselbe Navigation wie bisher.
       Kein Timer ersetzt eine Antwort: der Timer laeuft NACH der Serverbestaetigung und
       verzoegert nur den Seitenwechsel. Ohne ladenden Button (z. B. ein Kaufpfad ohne
       data-rb-atc) wird sofort navigiert - exakt das alte Verhalten. */
    var RB_DONE_MS = 300;
    function markDone() {
      var list = document.querySelectorAll('[data-rb-atc][aria-busy="true"]');
      if (!list.length) return false;
      Array.prototype.forEach.call(list, function (b) {
        /* Breite einfrieren: "Added" ist kuerzer als das Label - die Leiste soll nicht springen. */
        if (b.offsetWidth) b.style.width = b.offsetWidth + 'px';
        b.classList.add('is-done');
      });
      return true;
    }
    function finish(go) {
      if (markDone()) window.setTimeout(go, RB_DONE_MS);
      else go();
    }
    function goToCartOrOpenDrawer(onSuccess) {
      if (window.RiwiCartDrawerEnabled) {
        if (typeof onSuccess === 'function') onSuccess();
        document.dispatchEvent(
          new CustomEvent('riwi:cart:updated', { bubbles: true, detail: { source: 'riwi-lp2' } })
        );
        return;
      }
      finish(function () { window.location.href = cartHref(); });
    }
    /* Vorhandene + neue Codes, dedupliziert und case-insensitiv (Shopify vergleicht so). */
    function mergeCodes(existing, adds) {
      var out = [], seen = {};
      (existing || []).forEach(function (e) {
        var c = (e && e.code ? String(e.code) : '').trim();
        if (c && !seen[c.toUpperCase()]) { seen[c.toUpperCase()] = 1; out.push(c); }
      });
      (adds || []).forEach(function (c) {
        c = (c || '').trim();
        if (c && !seen[c.toUpperCase()]) { seen[c.toUpperCase()] = 1; out.push(c); }
      });
      return out.join(',');
    }
    function findEntry(cart, code) {
      var list = cart && cart.discount_codes;
      if (!list || !list.length || !code) return null;
      var want = String(code).toUpperCase();
      for (var i = 0; i < list.length; i++) {
        if (String(list[i].code || '').toUpperCase() === want) return list[i];
      }
      return null;
    }
    function postJson(target, payload) {
      return window.fetch(target, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        return r.json().then(
          function (d) { return { ok: r.ok, status: r.status, data: d }; },
          function () { return { ok: false, status: r.status, data: null }; }
        );
      });
    }
    /* F4 (17.09.2026) — Codes werden AUSSCHLIESSLICH aus dem echten Warenkorb gemergt.
       Befund QA F1/F2/F3 (reports/riwi-us-cart/qa-f123.md): die Antwort von POST cart/add.js
       ist das LINE-ITEM-Objekt und hat KEIN Feld `discount_codes` - das gibt es nur im
       Cart-Objekt von cart.js / cart/update.js / cart/change.js. `add.data.discount_codes`
       war also immer undefined, update.js bekam NUR den neuen Code und ersetzte damit jeden
       bereits aktiven (FREE12-XXL / FREEBAG-24) STILL - ohne Fehler, nur am Preis sichtbar.
       Liefert { ok, status, codes, cart }. ok === false heisst: Zustand UNBEKANNT.
       Wichtig: Cart-Endpunkte werden gedrosselt (429/430) und antworten dann mit einem
       LEEREN Cart - ein leeres discount_codes bei Status != 200 ist KEIN Befund, deshalb
       gilt nur eine 200-Antwort mit echtem Array als bekannt. */
    function currentCodes() {
      return window.fetch(url('cart.js'), {
        credentials: 'same-origin', headers: { 'Accept': 'application/json' }
      }).then(function (r) {
        if (!r.ok) return { ok: false, status: r.status, codes: [], cart: null };
        return r.json().then(function (c) {
          var list = c && c.discount_codes;
          if (!list || Object.prototype.toString.call(list) !== '[object Array]') {
            return { ok: false, status: r.status, codes: [], cart: c || null };
          }
          return { ok: true, status: r.status, codes: list, cart: c };
        }, function () { return { ok: false, status: r.status, codes: [], cart: null }; });
      }, function () { return { ok: false, status: 0, codes: [], cart: null }; });
    }
    /* opts: { items, codes, dropIfCodeFails, onError, tag } - liefert ein Promise, das im
       Erfolgsfall NICHT aufloest (die Seite navigiert). onError bekommt den Klartext. */
    function addAndApply(opts) {
      var items = (opts && opts.items) || [];
      var codes = ((opts && opts.codes) || []).filter(Boolean);
      var drop = (opts && opts.dropIfCodeFails) || [];
      var tag = (opts && opts.tag) || 'riwi-lp2 cart';
      var fail = (opts && opts.onError) || function () {};
      if (!items.length) { fail('Something went wrong — please try again.'); return window.Promise.resolve(); }
      /* Ohne fetch waere eine Navigation auf /cart eine Luege: es liegt nichts drin. Die
         aufrufenden Hooks pruefen fetch deshalb VOR dem preventDefault, damit in so einem
         Browser das native Formular laeuft. Kommt trotzdem jemand hier an: melden, nicht gehen. */
      if (typeof window.fetch !== 'function') { fail('Something went wrong — please try again.'); return window.Promise.resolve(); }

      return postJson(url('cart/add.js'), { items: items }).then(function (add) {
        if (!add.ok) {
          var why = add.data && (add.data.description || add.data.message);
          console.error('[' + tag + '] cart/add.js fehlgeschlagen', add.status, why || add.data);
          fail(why || 'Something went wrong — please try again.');
          return;
        }
        if (!codes.length) { goToCartOrOpenDrawer(opts && opts.onSuccess); return; }
        /* Erst den AKTUELLEN Warenkorb lesen, dann mergen - nie aus der add.js-Antwort. */
        return currentCodes().then(function (state) {
          if (!state.ok) {
            /* Zustand unbekannt (Drosselung/Netz). Eine update.js-Liste aus NUR den neuen
               Codes wuerde einen bereits gesetzten Rabatt still loeschen -> Codes-Schritt
               auslassen und NICHTS mutieren; der Warenkorb zeigt gleich die Wahrheit. */
            console.warn('[' + tag + '] cart.js nicht lesbar (Status ' + state.status + ') - ' +
              'Rabattcodes werden NICHT gesetzt, um bestehende Codes nicht zu ueberschreiben.', codes);
            goToCartOrOpenDrawer(opts && opts.onSuccess);
            return;
          }
          var merged = mergeCodes(state.codes, codes);
          return postJson(url('cart/update.js'), { discount: merged }).then(function (upd) {
            /* Gratis-Positionen zuerst pruefen: sie LIEGEN jetzt im Warenkorb. */
            var removals = [];
            drop.forEach(function (d) {
              if (!d || !d.code || !d.id) return;
              var e = upd.ok ? findEntry(upd.data, d.code) : null;
              if (e && e.applicable === true) return;
              /* cart/change.js adressiert die VARIANTE, nicht die Zeile. Hat der Kunde dieselbe
                 Farbe einmal gratis und einmal bezahlt gewaehlt, liegt sie als EINE Zeile mit
                 Menge 2 im Korb - quantity:0 wuerde auch das Bezahlte wegwerfen. Deshalb auf die
                 Menge zuruecksetzen, die NICHT an diesem Gratis-Code haengt. */
              var keep = 0;
              items.forEach(function (it) { if (String(it.id) === String(d.id)) keep += (it.quantity || 1); });
              drop.forEach(function (o) { if (o && String(o.id) === String(d.id)) keep -= 1; });
              if (keep < 0) keep = 0;
              console.warn('[' + tag + '] Code ' + d.code + ' nicht anwendbar - Gratis-Position ' +
                d.id + ' wird auf Menge ' + keep + ' zurueckgesetzt.',
                { entry: e, discount_codes: upd.data && upd.data.discount_codes });
              removals.push(postJson(url('cart/change.js'), { id: String(d.id), quantity: keep })['catch'](function () {}));
            });
            var after = removals.length ? window.Promise.all(removals) : window.Promise.resolve();
            return after.then(function () {
              var primary = codes[0];
              var entry = upd.ok ? findEntry(upd.data, primary) : null;
              if (entry && entry.applicable === true) { goToCartOrOpenDrawer(opts && opts.onSuccess); return; }
              console.warn('[' + tag + '] Leitcode ' + primary + ' nicht anwendbar, Fallback /discount/.',
                { status: upd.status, entry: entry, discount_codes: upd.data && upd.data.discount_codes });
              finish(function () { window.location.href = discountRoute(primary); });
            });
          });
        });
      })['catch'](function (err) {
        /* Netzwerkfehler: der Warenkorb-Zustand ist unbekannt -> NICHT navigieren. */
        console.error('[' + tag + '] Warenkorb-Anfrage fehlgeschlagen', err);
        fail('Something went wrong — please try again.');
      });
    }
    return {
      root: root, url: url, cartHref: cartHref, discountRoute: discountRoute,
      mergeCodes: mergeCodes, findEntry: findEntry, postJson: postJson, addAndApply: addAndApply,
      currentCodes: currentCodes,
      goToCartOrOpenDrawer: goToCartOrOpenDrawer
    };
  })();
  window.RiwiLp2Cart = Cart;

  ready(function () {

    /* ---------------------------------------------------------------- Scope-Flag
       .reveal startet erst dann unsichtbar, wenn das JS wirklich laeuft. Sonst waere
       die halbe Seite bei einem JS-Fehler dauerhaft opacity:0. */
    var roots = $$('.riwi-lp2');
    roots.forEach(function (r) { r.classList.add('is-js'); });

    /* ---------------------------------------------------------------- Glyph-Fallback
       RIWI Display hat fuer den Mittelpunkt eine LEERE Glyphe (cmap-Eintrag vorhanden,
       Umriss leer) - das Zeichen verschwindet still, ohne Browser-Fallback. Betroffene
       Zeichen werden deshalb in einen Body-Font-Span umgehaengt. */
    (function () {
      var CHARS = /[·]/;
      var RE = new RegExp(CHARS.source, 'g');
      var SEL = 'h1,h2,h3,.disp,.bundle-price,.rating-score,.sig,.sig-line,.set-price strong';
      roots.forEach(function (root) {
        $$(SEL, root).forEach(function (el) {
          var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
          var hits = [], n;
          while ((n = walker.nextNode())) { if (CHARS.test(n.nodeValue)) hits.push(n); }
          hits.forEach(function (node) {
            if (!node.parentNode) return;
            var frag = document.createDocumentFragment();
            var s = node.nodeValue, last = 0, m;
            RE.lastIndex = 0;
            while ((m = RE.exec(s))) {
              if (m.index > last) frag.appendChild(document.createTextNode(s.slice(last, m.index)));
              var sp = document.createElement('span');
              sp.className = m[0] === '®' ? 'gf gf-sup' : 'gf';
              sp.textContent = m[0];
              frag.appendChild(sp);
              last = m.index + m[0].length;
            }
            if (last < s.length) frag.appendChild(document.createTextNode(s.slice(last)));
            node.parentNode.replaceChild(frag, node);
          });
        });
      });
    })();

    /* ---------------------------------------------------------------- Galerie + Lightbox */
    (function () {
      var hero = $('[data-riwi-lp2-hero]');
      if (!hero) return;

      var mainImage = $('[data-main-image]', hero);
      var stage = mainImage ? mainImage.closest('.main-image') : null;
      var strip = $('.thumbs', hero);
      /* PDP-Modus: die Thumb-Leiste wird beim Set-Wechsel UMSORTIERT. `thumbs` ist deshalb
         bewusst kein eingefrorenes Abbild - nach jedem Umhaengen wird die Liste neu aus dem
         DOM gelesen, damit Index und Knoten nie auseinanderlaufen. In der LP2 aendert sich
         die Reihenfolge nie, das Verhalten ist dort identisch zu vorher. */
      var thumbs = $$('.thumb', hero);
      var PDP = hero.getAttribute('data-gallery-mode') === 'pdp';
      /* T6 (25.10.2026): CUT = Bezug-Bild mobil ohne Weissraum (.main-image.is-cut, Hero-Setting cover_image_cut),
         CPL = Zustand B nur mit Komplett-Bild (complete_image_map). Ohne die Attribute aendert sich nichts. */
      var CUT = hero.hasAttribute('data-cs-cut'), CPL = hero.hasAttribute('data-cpl');
      /* T7 (Owner 25.10.2026): Hinweis "Abbildung zeigt Beispielfarbe" am Hauptbild - sichtbar genau dann, wenn
         das Hauptbild der Farb-Slot mit Ersatzbild ist (Slot data-ex, Zustand B, Farbe ohne Komplett-Bild). */
      var NOTE = CPL ? $('[data-cpl-note]', hero) : null;
      if (!mainImage || !stage) return;

      /* F45 (PDP): die vier Varianten-Renders liegen ALLE in der Leiste, sichtbar ist nur der
         des gewaehlten Sets - der Set-Wechsel kommt so ohne Nachladen aus. Zwei Listen:
           allThumbs = alles, was im DOM steht (Klick-Listener, Umsortieren)
           thumbs    = nur das SICHTBARE (Index, Lightbox, Pfeiltasten, Wischen)
         Ohne die Trennung landete ein Pfeiltasten-Schritt auf einem versteckten Bild.
         In der LP2 traegt kein Thumb ein hidden-Attribut, beide Listen sind dort gleich. */
      var allThumbs = thumbs.slice();
      if (PDP) thumbs = thumbs.filter(function (t) { return !t.hidden; });

      var current = 0;
      var seq = 0;

      /* Ein recyceltes <img> zeigt beim src-Wechsel weiter den ALTEN Frame, bis der neue
         dekodiert ist. Deshalb erst dekodieren, dann tauschen - und nur, wenn inzwischen
         kein neuerer Wechsel angefordert wurde (Sequenz-Token). Die Buehne hat via CSS
         eine definite Groesse (aspect-ratio), es entsteht also kein Layout-Sprung.

         srcset MUSS mitgetauscht werden: bleibt das alte srcset stehen, waehlt der Browser
         weiter aus dem ALTEN Kandidatensatz - der neue src wird dann ignoriert und das Bild
         wechselt gar nicht. Deshalb erst srcset leeren, dann src+srcset gemeinsam setzen.
         data-full haelt die 1400er-URL fuer die Lightbox (currentSrc waere mobil die
         400er-Variante). */
      function swap(img, src, srcset, cut, ex) {
        if (!img || !src) return;
        var sameSrc = img.getAttribute('src') === src;
        var sameSet = (img.getAttribute('srcset') || '') === (srcset || '');
        /* Gate 5 B1 (15.10.2026): Token IMMER erhoehen - auch wenn das Ziel schon steht. Sonst
           schreibt ein noch laufender Vor-Swap (Farbe Y) nach dem Rueckklick auf X sein Bild. */
        var token = ++seq;
        var box = cut === undefined && ex === undefined ? null : img.closest('.main-image');
        var fx = function () {
          if (cut !== undefined) box.classList.toggle('is-cut', cut);
          if (ex !== undefined && NOTE) NOTE.hidden = !ex;
        };
        if (sameSrc && sameSet) { if (box) fx(); return; }
        var done = false;
        var pre = new Image();
        if (srcset) { pre.srcset = srcset; pre.sizes = img.getAttribute('sizes') || '100vw'; }
        var go = function () {
          if (done || token !== seq) return;
          done = true;
          if (srcset) img.setAttribute('srcset', srcset);
          else img.removeAttribute('srcset');
          img.setAttribute('src', src);
          img.setAttribute('data-full', src);
          if (box) fx();
        };
        pre.src = src;
        if (pre.complete) { go(); return; }
        /* DREI Ausloeser statt einem - das Bild darf NIE auf dem alten Render stehen bleiben:
           1. load/error: feuert in jeder Engine, auch wenn decode() haengt,
           2. decode(): der eigentlich gewollte Weg (fertig dekodiert = kein Halbbild),
           3. Waechter-Timer: letzte Absicherung. decode() eines <img>, das NICHT im Dokument
              haengt, loest in manchen Engines gar nicht aus - dann blieben src UND srcset auf
              dem alten Set-Render, obwohl die Kachel den richtigen data-image traegt (genau
              das Fehlerbild F1: Thumbs sortieren um, das Hauptbild nicht).
           `done` sorgt dafuer, dass nur der erste Ausloeser schreibt. */
        pre.onload = go;
        pre.onerror = go;
        if (pre.decode) pre.decode().then(go).catch(go);
        window.setTimeout(go, 500);
      }

      function markThumb(i) {
        thumbs.forEach(function (t, j) { t.classList.toggle('active', i === j); });
        var el = thumbs[i];
        /* NIE scrollIntoView: das scrollt bei Aufruf aus der Sticky-Leiste die SEITE zur
           Galerie hoch. Stattdessen nur den Thumb-Strip selbst horizontal zentrieren. */
        var strip = el ? el.closest('.thumbs') : null;
        if (el && strip && strip.scrollWidth > strip.clientWidth + 1) {
          var target = Math.max(0, el.offsetLeft - (strip.clientWidth - el.offsetWidth) / 2);
          try { strip.scrollTo({ left: target, behavior: 'smooth' }); } catch (e) { strip.scrollLeft = target; }
        }
      }

      function showImage(i) {
        if (i < 0 || i >= thumbs.length) return;
        current = i;
        swap(mainImage, thumbs[i].getAttribute('data-large'), thumbs[i].getAttribute('data-large-srcset'), CUT ? thumbs[i].hasAttribute('data-cut') : undefined,
          NOTE ? !!(slot && thumbs[i] === slot && slot.hasAttribute('data-ex')) : undefined);
        markThumb(i);
      }

      /* Index ERST beim Klick bestimmen (nicht beim Binden): nach einem Umsortieren waere ein
         eingefrorener Index das falsche Bild. */
      allThumbs.forEach(function (t) {
        t.addEventListener('click', function () { showImage(thumbs.indexOf(t)); });
      });

      /* PDP: das Set-Render der gewaehlten Variante rueckt an Position 1 der Leiste - genau
         das Verhalten der LP1 ("Bild des gewaehlten Sets zuerst"). Nur Thumbs, die ein
         Set-Render zeigen, tragen data-set-render; alle anderen bleiben in ihrer Reihenfolge.

         WICHTIG (F2): die Reihenfolge wird bei JEDEM Wechsel neu aus der SERVER-Reihenfolge
         abgeleitet, nie aus dem aktuellen DOM-Zustand. Ein blosses "nach vorn schieben"
         baut sonst eine Historie auf - nach drei Wechseln stuenden 48, 24, 12 vorn und die
         Fotos waeren nach hinten gewandert. baseOrder ist die eingefrorene Auslieferung. */
      var baseOrder = allThumbs.slice();
      function applySetRenderOrder(blocks) {
        if (!PDP || !strip || !baseOrder.length) return;
        var n = parseInt(blocks, 10) || 0;
        var pick = null;
        if (n) {
          for (var i = 0; i < baseOrder.length; i++) {
            if ((parseInt(baseOrder[i].getAttribute('data-set-render'), 10) || 0) === n) { pick = baseOrder[i]; break; }
          }
        }
        /* F45: die Set-Renders schliessen sich aus - sichtbar ist genau der des gewaehlten
           Sets, an Position 1; die drei anderen bleiben im DOM, aber verborgen und ganz am
           Ende der Leiste, damit sie keine Luecke in der sichtbaren Reihenfolge hinterlassen.
           Findet sich zum Set KEIN Render (Variante ohne Verknuepfung), bleibt alles sichtbar:
           lieber die ausgelieferte Reihenfolge als eine leere Leiste. */
        var vis = [], hid = [];
        baseOrder.forEach(function (t) {
          var r = parseInt(t.getAttribute('data-set-render'), 10) || 0;
          if (!r || !pick || t === pick) {
            t.hidden = false;
            if (t !== pick) vis.push(t);
          } else {
            t.hidden = true;
            hid.push(t);
          }
        });
        if (pick) vis.unshift(pick);
        var want = vis.concat(hid);
        var same = want.length === strip.children.length;
        for (var j = 0; same && j < want.length; j++) { if (strip.children[j] !== want[j]) same = false; }
        thumbs = vis.slice();
        if (same) return;
        /* In EINEM Rutsch umhaengen (Fragment): so entsteht nur ein Reflow, und die Leiste
           flackert nicht durch zehn Einzelbewegungen. appendChild verschiebt, klont nicht -
           Klick-Listener der Thumbs bleiben also erhalten. */
        var frag = document.createDocumentFragment();
        want.forEach(function (t) { frag.appendChild(t); });
        strip.appendChild(frag);
        /* Die Leiste scrollt sonst mit dem alten Offset weiter - ohne Reset waere das neue
           erste Bild aus dem sichtbaren Bereich geschoben. */
        strip.scrollLeft = 0;
      }

      /* Galerie je Option (Couch-Produkt-Umschalter, 14.10.2026). Nur mit data-opt /
         data-opt-first an den Thumbs (Hero-Settings bundle_gallery_*) - sonst kehrt die
         Funktion sofort mit false zurueck und nichts aendert sich.
         Zustand A: Nur-B-Thumbs verborgen; Bild 1 = Bild der aktiven Farbe, ausser es ist ein
         Nur-B-Bild -> das A-Ersatzbild. Zustand B: alle Thumbs; Bild 1 = das B-Bild.
         Laeuft nach jedem Farbwechsel neu, weil selectTile() -> applySetRenderOrder() im
         Farbmodus alle Thumbs wieder einblendet. */
      var optThumbs = allThumbs.filter(function (t) { return t.hasAttribute('data-opt') || t.hasAttribute('data-opt-first'); });
      /* F28 (Owner 15.10.2026): Farb-Slot - Bild 1 = Bild der gewaehlten Farbe in der gewaehlten
         Option (data-bp-* = Complete, data-cs-a* = Covers am aktiven Farbfeld). Ohne Bild fuer die
         Farbe wird der Slot verborgen und das erste allgemeine Bild gezeigt - nie eine fremde Farbe.
         Nur mit [data-color-slot] im DOM (Hero-Setting gallery_color_slot). */
      var slot = $('[data-color-slot]', hero);
      /* T5 (Owner 02.11.2026): feste Galerie (Hero-Setting gallery_fixed) - ein Galeriebild, das
         dasselbe Foto wie Bild 1 zeigt (Dateiname ohne Endung/Upload-Suffix), wird verborgen und
         nach dem naechsten Farbwechsel wieder gezeigt. Nur mit data-gallery-dk an der Hero. */
      var DK = hero.hasAttribute('data-gallery-dk');
      function dkey(u) {
        u = (u || '').split('?')[0];
        return u.substring(u.lastIndexOf('/') + 1).toLowerCase().replace(/\.[a-z0-9]+$/, '')
          .replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/, '');
      }
      function dedupeSlot() {
        if (!DK || !slot) return;
        var k = slot.hidden ? '' : dkey(slot.getAttribute('data-large'));
        allThumbs.forEach(function (t) {
          if (t === slot) return;
          if (t.hasAttribute('data-dk-hid')) { t.hidden = false; t.removeAttribute('data-dk-hid'); }
          if (k && !t.hidden && dkey(t.getAttribute('data-large')) === k) { t.hidden = true; t.setAttribute('data-dk-hid', ''); }
        });
      }
      hero.__lp2ColorSlot = slot ? function (state) {
        var act = $('.variant.active', hero);
        var L = '', S = '', T = '';
        if (act) {
          if (state === 'b') { L = act.getAttribute('data-bp-image') || ''; S = act.getAttribute('data-bp-srcset') || ''; T = act.getAttribute('data-cs-b-t') || ''; }
          else { L = act.getAttribute('data-cs-a') || ''; S = act.getAttribute('data-cs-a-ss') || ''; T = act.getAttribute('data-cs-a-t') || ''; }
        }
        if (L) {
          if (CUT) { if (state === 'b') slot.removeAttribute('data-cut'); else slot.setAttribute('data-cut', ''); }
          if (state === 'b' && act.hasAttribute('data-cpl-ex')) slot.setAttribute('data-ex', ''); else slot.removeAttribute('data-ex');
          slot.setAttribute('data-large', L);
          slot.setAttribute('data-large-srcset', S);
          var im = slot.querySelector('img');
          if (im) { im.removeAttribute('srcset'); im.setAttribute('src', T || L); }
          slot.hidden = false;
        } else if (state === 'b' && CPL) {
          /* T6 (Owner 25.10.2026): Farbe ohne Komplett-Bild -> Bild NICHT umschalten, das zuletzt gezeigte
             bleibt stehen (wie "Variantenbild nicht verfuegbar"); nur die Leiste folgt der Option. */
          var keep = thumbs[current];
          if (NOTE) NOTE.hidden = false;
          dedupeSlot();
          thumbs = baseOrder.filter(function (t) { return !t.hidden; });
          current = Math.max(0, thumbs.indexOf(keep));
          markThumb(current);
          return true;
        } else {
          slot.hidden = true;
        }
        dedupeSlot();
        thumbs = baseOrder.filter(function (t) { return !t.hidden; });
        var idx = slot.hidden ? 0 : thumbs.indexOf(slot);
        showImage(idx < 0 ? 0 : idx);
        return true;
      } : null;
      hero.__lp2OptGallery = function (state) {
        if (!PDP || (!optThumbs.length && !slot)) return false;
        allThumbs.forEach(function (t) {
          var o = t.getAttribute('data-opt');
          if (o) t.hidden = o !== state;
        });
        if (slot) return hero.__lp2ColorSlot(state);
        thumbs = baseOrder.filter(function (t) { return !t.hidden; });
        var act = $('.variant.active', hero);
        var img = act ? act.getAttribute('data-image') : '';
        var actThumb = null;
        thumbs.forEach(function (t) { if (!actThumb && img && t.getAttribute('data-large') === img) actThumb = t; });
        var bFirst = $('.thumb[data-opt-first="b"]', hero);
        var aFirst = $('.thumb[data-opt-first="a"]', hero);
        var pick = state === 'b' ? (bFirst || actThumb) : (actThumb || aFirst);
        var idx = pick ? thumbs.indexOf(pick) : -1;
        showImage(idx < 0 ? 0 : idx);
        return true;
      };
      if (optThumbs.length || slot) {
        hero.addEventListener('riwi:lp2:variant', function () {
          hero.__lp2OptGallery(hero.getAttribute('data-bundle-state') === 'b' ? 'b' : 'a');
        });
      }

      function stepGallery(d) {
        if (!thumbs.length) return;
        showImage((current + d + thumbs.length) % thumbs.length);
      }

      /* ---- Mobile Galerie: durchswipen (<=980px, deckungsgleich mit der Thumb-Overlay-
         Leiste). Nur Touch-Pointer, damit Maus-Drag/Trackpad unberuehrt bleiben. Schwellwert
         >=40px horizontal UND <30px vertikal loest den Bildwechsel aus; ueberwiegt die
         Vertikal-Bewegung (locked), bleibt es normales Scrollen - touch-action:pan-y am
         Hauptbild laesst den Browser diese Faelle selbst uebernehmen. Ein Bewegungs-Flag
         verhindert, dass ein Wisch zusaetzlich den Klick (Lightbox) ausloest. */
      (function () {
        var GALLERY_TOUCH_MAX = 980;
        var startX = 0, startY = 0, active = false, moved = false, locked = false;
        var justSwiped = false;

        stage.addEventListener('pointerdown', function (e) {
          /* justSwiped hier zuruecksetzen, nicht erst im Klick-Handler: ein echter Drag
             loest bei den meisten Browsern GAR KEINEN Klick aus (nur ein Tap tut das) -
             ohne diesen Reset wuerde das Flag nach einem Wisch stehen bleiben und den
             naechsten, echten Tap faelschlich verschlucken. */
          justSwiped = false;
          if (e.pointerType !== 'touch' || window.innerWidth >= GALLERY_TOUCH_MAX) return;
          active = true; moved = false; locked = false;
          startX = e.clientX; startY = e.clientY;
        });

        stage.addEventListener('pointermove', function (e) {
          if (!active || e.pointerType !== 'touch' || locked) return;
          var dx = e.clientX - startX, dy = e.clientY - startY;
          if (Math.abs(dy) >= 30 && Math.abs(dy) > Math.abs(dx)) { locked = true; return; }
          if (Math.abs(dx) >= 40 && Math.abs(dy) < 30) moved = true;
        });

        function endTouch(e) {
          if (!active) return;
          active = false;
          if (locked || !moved || e.pointerType !== 'touch') return;
          justSwiped = true;
          stepGallery(e.clientX - startX < 0 ? 1 : -1);
        }
        stage.addEventListener('pointerup', endTouch);
        stage.addEventListener('pointercancel', function () { active = false; });

        /* Capture-Phase: vor dem oeffnenden Klick-Handler pruefen und den Wisch-Klick
           schlucken, ohne den Handler selbst zu duplizieren. */
        stage.addEventListener('click', function (e) {
          if (justSwiped) { justSwiped = false; e.stopImmediatePropagation(); e.preventDefault(); }
        }, true);
      })();

      /* Lightbox-Knoten per JS an <body> haengen: innerhalb der Grid-Spalte wuerde
         position:fixed an die Spalte binden (Dawn-Scroll-Animationen lassen einen
         transform stehen), nicht an den Viewport. Der Portal-Knoten traegt selbst
         .riwi-lp2, damit der CSS-Scope weiter greift. */
      var portal = document.createElement('div');
      portal.className = 'riwi-lp2 is-js riwi-lp2-portal';
      portal.innerHTML =
        '<div class="lightbox" hidden role="dialog" aria-modal="true" aria-label="Product image">' +
        '<button class="lb-close" type="button" aria-label="Close">&times;</button>' +
        '<button class="lb-nav lb-prev" type="button" aria-label="Previous image">&#8249;</button>' +
        '<img alt="" decoding="async">' +
        '<button class="lb-nav lb-next" type="button" aria-label="Next image">&#8250;</button>' +
        '</div>';
      document.body.appendChild(portal);

      var lb = $('.lightbox', portal);
      var lbImg = $('img', lb);
      var lbClose = $('.lb-close', lb);
      var lastFocus = null;

      lbImg.alt = mainImage.getAttribute('alt') || '';

      function openLb() {
        lastFocus = document.activeElement;
        /* data-full statt currentSrc: mit srcset waere currentSrc mobil die 400-px-Variante
           und die Lightbox damit unscharf. */
        lbImg.src = mainImage.getAttribute('data-full') || mainImage.currentSrc || mainImage.src;
        lb.hidden = false;
        document.body.style.overflow = 'hidden';
        lbClose.focus();
      }
      function closeLb() {
        lb.hidden = true;
        document.body.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      function stepLb(d) {
        if (!thumbs.length) return;
        var next = (current + d + thumbs.length) % thumbs.length;
        showImage(next);
        /* Lightbox immer in voller Aufloesung, unabhaengig vom srcset des Buehnenbilds. */
        lbImg.src = thumbs[next].getAttribute('data-large');
      }

      stage.addEventListener('click', openLb);
      stage.setAttribute('role', 'button');
      stage.setAttribute('tabindex', '0');
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLb(); }
      });
      lbClose.addEventListener('click', closeLb);
      $('.lb-prev', lb).addEventListener('click', function (e) { e.stopPropagation(); stepLb(-1); });
      $('.lb-next', lb).addEventListener('click', function (e) { e.stopPropagation(); stepLb(1); });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target === lbImg) closeLb(); });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowLeft') stepLb(-1);
        if (e.key === 'ArrowRight') stepLb(1);
      });

      /* ------------------------------------------------------------ Variantenwechsel */
      var priceEl = $('[data-price]', hero);
      var oldEl = $('[data-old-price]', hero);
      var perEl = $('[data-per-block]', hero);
      /* F24: Alternative zum orangen Chip - Stueckpreis als Text in derselben Zeile. Beide
         Knoten schliessen sich aus (Liquid rendert nur einen), deshalb hier zwei Referenzen
         statt einer Fallunterscheidung. Der Text ist SERVERSEITIG fertig formatiert und haengt
         als data-per-fmt an der Kachel - im Browser wird nie Geld formatiert. */
      var perFmtEl = $('[data-price-per]', hero);
      var setEl = $('[data-selected-set]', hero);
      var idInput = $('input[data-variant-id]', hero);
      var atc = $('[data-atc]', hero);
      var atcLabel = atc ? $('[data-atc-label]', atc) : null;
      /* Button-System v2: Preis-Chip im Haupt-ATC (nur dort; Sticky und Cart haben keinen). */
      var atcChip = atc ? $('[data-atc-chip]', atc) : null;
      var tiles = $$('.variant', hero);

      /* Set-Dropdown der Sticky-Leiste: ZWEITER EINGANG in dieselbe Auswahl, nie eine zweite
         Wahrheit. Die Referenz wird HIER geholt, waehrend die Leiste noch in der Section
         haengt - das spaetere Umhaengen ins Body-Portal verschiebt denselben Knoten
         (appendChild klont nicht), die Referenz bleibt also gueltig. */
      var stickySel = $('[data-sticky-select]', hero);

      /* Farbmodus (variant_mode=colors): Knoten fuer das Label der Preisstufe neben dem
         Farbnamen. Auf der Landingpage und der Bausteine-PDP existiert er nicht - dann ist
         die Referenz null und alles Folgende laeuft wie bisher. */
      var tierEl = $('[data-sw-tier]', hero);

      function selectTile(v) {
        tiles.forEach(function (x) {
          x.classList.remove('active');
          x.setAttribute('aria-pressed', 'false');
          /* Farb-Swatches liegen als role=radio in einer radiogroup - dort ist aria-checked
             der Zustand, nicht aria-pressed. Beides zu setzen kostet nichts und haelt die
             Auswahl in EINER Funktion. */
          if (x.getAttribute('role') === 'radio') x.setAttribute('aria-checked', 'false');
        });
        v.classList.add('active');
        v.setAttribute('aria-pressed', 'true');
        if (v.getAttribute('role') === 'radio') v.setAttribute('aria-checked', 'true');

        var d = v.dataset;
        if (priceEl) priceEl.textContent = d.price || '';
        if (oldEl) {
          oldEl.textContent = d.old || '';
          oldEl.hidden = !d.old;
        }
        if (perEl) {
          perEl.textContent = ((d.old ? (perEl.getAttribute('data-now-label') || '') + ' ' : '') + (d.per || '')).trim();
          perEl.hidden = !d.per;
        }
        if (perFmtEl) {
          perFmtEl.textContent = d.perFmt || '';
          perFmtEl.hidden = !d.perFmt;
        }
        if (setEl) setEl.textContent = d.name || '';
        if (tierEl) {
          tierEl.textContent = d.tierLabel || '';
          tierEl.hidden = !d.tierLabel;
        }
        if (idInput && d.id) idInput.value = d.id;

        if (atc) {
          var sold = d.available === 'false';
          atc.setAttribute('aria-disabled', sold ? 'true' : 'false');
          atc.disabled = !!sold;
          if (atcLabel) {
            atcLabel.textContent = sold
              ? (atc.getAttribute('data-soldout-label') || 'Sold out')
              : (atc.getAttribute('data-add-label') || atcLabel.textContent);
          }
          /* Chip = Variantenpreis, serverseitig formatiert (data-price der Kachel, dasselbe
             money-Format wie die Buybox). Ausverkauft -> kein Preis im Button. */
          if (atcChip) {
            atcChip.textContent = d.price || '';
            atcChip.hidden = !!sold || !d.price;
          }
        }

        if (d.image) {
          /* Reihenfolge: ERST umsortieren, DANN den Index bestimmen, DANN das Bild tauschen.
             Sonst zeigte die Lightbox waehrend des Bildwechsels noch auf die alte Position
             und "weiter" spraenge mitten in die Fotos.
             Gibt es zum Set-Render einen Thumb, laeuft der Bildwechsel ueber GENAU DEN
             Galerie-Pfad (showImage) - eine Quelle fuer src+srcset, kein zweiter Weg, der
             auseinanderlaufen kann. Nur ohne passenden Thumb greift der Kachel-Fallback. */
          applySetRenderOrder(d.blocks);
          var idx = -1;
          thumbs.forEach(function (t, j) { if (idx < 0 && t.getAttribute('data-large') === d.image) idx = j; });
          if (idx >= 0) showImage(idx);
          else swap(mainImage, d.image, d.srcset || '');
        }

        /* PDP: die Adresszeile fuehrt die gewaehlte Variante mit (Teilen, Neuladen, Zurueck).
           replaceState statt pushState: ein Set-Wechsel ist kein Seitenwechsel - sonst muesste
           sich der Kunde durch jede angeklickte Kachel zurueckarbeiten. */
        if (PDP && d.id && window.history && window.history.replaceState) {
          try {
            var u = new URL(window.location.href);
            /* R1 Bundle-Seite (data-rb-mirror, 23.10.2026): die Adresszeile fuehrt die BUNDLE-Variante derselben
               Farbe (data-bp-id), damit Neuladen/Teilen der Bundle-URL wieder Komplett + Farbe zeigt. */
            u.searchParams.set('variant', (hero.getAttribute('data-rb-mirror') === '1' && d.bpId) ? d.bpId : d.id);
            window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
          } catch (e) { /* alter Browser: Auswahl funktioniert, nur die URL bleibt stehen */ }
        }

        /* Spiegel Kachel -> Dropdown der Leiste. Bewusst NUR der Wert und KEIN change-Event:
           das wuerde den Handler unten erneut aufrufen (Rekursion). */
        if (stickySel && d.id && stickySel.value !== String(d.id)) stickySel.value = String(d.id);

        /* Die Sticky-Leiste haengt sich HIER ein, statt einen zweiten Klick-Handler auf
           dieselben Kacheln zu legen: so ist die Reihenfolge eindeutig und die Leiste
           spiegelt garantiert denselben Zustand wie die Buybox. */
        try {
          hero.dispatchEvent(new CustomEvent('riwi:lp2:variant', { detail: d }));
        } catch (err) { /* CustomEvent nicht verfuegbar: Leiste bleibt beim Startzustand */ }
      }

      tiles.forEach(function (v) {
        v.addEventListener('click', function () { selectTile(v); });
      });

      /* ---- Farb-Swatches: Tastatur + Bestand (nur variant_mode=colors) -------------------
         Die Reihe ist eine radiogroup: EIN Swatch ist im Tabstopp, die Pfeiltasten wandern.
         Gewaehlt wird ueber .click() - also durch GENAU dieselbe selectTile() wie ein
         Mausklick. Kein zweiter Auswahlpfad, keine zweite Preis- oder Bildwahrheit.
         Ohne Swatches (Landingpage, Bausteine-PDP) ist die Liste leer und nichts passiert. */
      var cvSw = tiles.filter(function (x) { return x.hasAttribute('data-cv-swatch'); });
      if (cvSw.length) {
        var cvRoving = function () {
          cvSw.forEach(function (b) { b.tabIndex = b.classList.contains('active') ? 0 : -1; });
        };
        hero.addEventListener('riwi:lp2:variant', cvRoving);
        cvSw.forEach(function (b) {
          b.addEventListener('keydown', function (e) {
            var d = 0;
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') d = 1;
            else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') d = -1;
            if (!d) return;
            e.preventDefault();
            /* Verborgene Farben (Bestandsfilter) werden uebersprungen - sonst landet der
               Tastaturnutzer auf einer Auswahl, die niemand sonst sieht. */
            /* T6: Reihenfolge kann sich zur Laufzeit aendern (swSort) - Tastatur folgt dem DOM. */
            cvSw.sort(function (x, y) { return x.compareDocumentPosition(y) & 4 ? -1 : 1; });
            var vis = cvSw.filter(function (x) { return !x.hidden; });
            if (!vis.length) return;
            var i = vis.indexOf(b);
            if (i < 0) i = 0;
            var n = vis[(i + d + vis.length) % vis.length];
            n.click();
            if (n.focus) n.focus();
          });
        });

        /* Bestandsfilter: dieselbe gebuendelte Storefront-Abfrage wie bei den Zubehoer-Farben
           (sie schreibt data-qty an den Swatch und meldet riwi:lp2:stock). Geprueft wird gegen
           die Stueckzahl der Kaufform - heute fest 1. OHNE data-qty wird NICHT gefiltert:
           Fehlerfall = ausgelieferter Stand. Faellt die aktive Farbe weg, rueckt die erste
           lieferbare nach; eine unsichtbare Auswahl ginge sonst stumm in den Warenkorb. */
        hero.addEventListener('riwi:lp2:stock', function () {
          var qEl = idInput && idInput.form ? idInput.form.querySelector('[name="quantity"]') : null;
          var need = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
          var vis = [], cur = null, soNew = false;
          cvSw.forEach(function (b) {
            var raw = b.getAttribute('data-qty');
            var ok = true;
            if (raw !== null && raw !== '') {
              var q = parseInt(raw, 10);
              ok = isNaN(q) ? true : q >= need;
            }
            /* Cord-Hauptfarbe (data-sok) bleibt am Platz und wird als ausverkauft markiert (CSS)
               statt ausgeblendet; kein stiller Wechsel auf eine andere Farbe. Der Server-Wert wird
               gemerkt und bei wieder ausreichendem Bestand zurueckgesetzt. */
            if (b.hasAttribute('data-sok')) {
              if (!ok) {
                if (!b.__soSrv) b.__soSrv = { a: b.getAttribute('data-available'), bp: b.getAttribute('data-bp-available') };
                if (b.getAttribute('data-available') !== 'false' && b.classList.contains('active')) soNew = true;
                b.setAttribute('data-available', 'false');
                if (b.getAttribute('data-bp-id')) b.setAttribute('data-bp-available', 'false');
                ok = true;
              } else if (b.__soSrv) {
                if (b.__soSrv.a === null) b.removeAttribute('data-available'); else b.setAttribute('data-available', b.__soSrv.a);
                if (b.__soSrv.bp === null) b.removeAttribute('data-bp-available'); else b.setAttribute('data-bp-available', b.__soSrv.bp);
                b.__soSrv = null;
                if (b.classList.contains('active')) soNew = true;
              }
            }
            b.hidden = !ok;
            if (ok) vis.push(b);
            if (b.classList.contains('active')) cur = b;
          });
          if (!vis.length) {                  /* nie alle ausblenden - dann lieber ungefiltert */
            cvSw.forEach(function (b) { b.hidden = false; });
            return;
          }
          if (!cur || cur.hidden) (vis.filter(function (x) { return x.getAttribute('data-available') !== 'false'; })[0] || vis[0]).click();
          else if (soNew) cur.click();
          cvRoving();
        });

        /* P4b (10.10.2026): Farbwahl in zwei Gruppen (swatch_featured_match). Blendet der
           Bestandsfilter (Hoerer direkt darueber, laeuft also vorher) ALLE Farben einer Gruppe
           aus, verschwindet die Gruppe samt Ueberschrift - keine leere Reihe, keine verwaiste
           Ueberschrift. Ohne Gruppen-Markup (heutige Seiten) ist die Liste leer: nichts passiert.
           Tastatur und Auswahl bleiben unberuehrt: cvSw laeuft in DOM-Reihenfolge ueber beide
           Gruppen, also erst die erste Gruppe, dann die zweite. */
        var swGroups = $$('[data-sw-group]', hero);
        if (swGroups.length) {
          hero.addEventListener('riwi:lp2:stock', function () {
            swGroups.forEach(function (g) {
              var any = $$('[data-cv-swatch]', g).some(function (b) { return !b.hidden; });
              g.hidden = !any;
              if (g.getAttribute('data-sw-group') === 'm') {
                var h = $('[data-sw-group-head]', hero);
                if (h) h.hidden = !any;
              }
            });
          });
        }
      }

      /* Dropdown -> DIESELBE selectTile(): dadurch aktualisieren sich Kachel-States, Galerie,
         Preis, Stueckpreis, FREE12-Promo-Box, Sticky-Anzeige, die Varianten-ID der Form und
         das Store-Modal-Mapping ueber genau EINEN Pfad - keine zweite Preis- oder
         Promo-Rechnung in der Leiste.
         Findet sich zur gewaehlten ID keine Kachel (Variante ohne Kachel), bleibt die
         Auswahl unveraendert und das Dropdown springt auf den aktiven Zustand zurueck: nie
         eine ID setzen, die die Buybox nicht kennt. */
      if (stickySel) {
        stickySel.addEventListener('change', function () {
          var want = stickySel.value, hit = null;
          tiles.forEach(function (x) { if (!hit && x.getAttribute('data-id') === want) hit = x; });
          if (hit) { selectTile(hit); return; }
          var act = $('.variant.active', hero);
          stickySel.value = act ? (act.getAttribute('data-id') || '') : '';
        });
      }

      /* ---- A/B-Test Standard-Set: Arm anwenden ------------------------------------------
         Der Arm ist beim Parsen schon zugeteilt (Inline-Script der Hero-Section, Attribut
         data-ab-blocks). Angewendet wird er ueber GENAU dieselbe selectTile() wie ein
         Nutzerklick - Kacheln, Preis, Stueckpreis, Galerie, Form-ID, Sticky-Leiste und die
         FREE12-Box folgen damit automatisch, ohne zweite Wahrheit.
         Bewusst ein direkter Funktionsaufruf und KEIN .click() auf der Kachel: sonst wuerde
         die programmatische Vorauswahl als Nutzer-Variantenwechsel gemessen
         (lp2_ab_variant_click) und die Auswertung verfaelschen.

         AUFGERUFEN WIRD DAS ERST GANZ AM ENDE von ready() (Block "A/B-Arm anwenden"),
         NICHT hier: Sticky-Leiste und FREE12-Box spiegeln den Variantenwechsel ueber
         riwi:lp2:variant, und ihre Listener sind zu diesem Zeitpunkt noch nicht
         registriert (ihre Module stehen weiter unten in dieser Datei). Wird der Arm hier
         angewendet, geht das Ereignis ins Leere: die Leiste zeigte dann weiter Set und
         PREIS der Kontrolle - im Test nachgewiesen (free12_cart_harness.js,
         "Sticky-Leiste Set/Preis").
         Ist der Test aus, fehlt data-ab-blocks -> die Funktion macht nichts. */
      hero.__lp2ApplyAbArm = function () {
        var abWant = parseInt(hero.getAttribute('data-ab-blocks'), 10) || 0;
        if (!abWant) return;
        var abTile = null;
        tiles.forEach(function (x) {
          if (!abTile && (parseInt(x.getAttribute('data-blocks'), 10) || 0) === abWant) abTile = x;
        });
        if (abTile && !abTile.classList.contains('active')) selectTile(abTile);
      };
    })();

    /* ------------------------------------------------- Sticky Add-to-cart (mobil UND Desktop)
       Sichtbar, sobald der Haupt-ATC-Button NACH OBEN aus dem Viewport gescrollt ist.
       Bewusst NICHT ueber isIntersecting entschieden: false ist zweideutig (ueberscrollt vs.
       noch nie erreicht - und der erste observe()-Callback feuert sofort). Entschieden wird
       allein ueber rect.top mit Hysterese; der Observer ist nur der Ausloeser.
       Beobachtet werden ausschliesslich Elemente, die die Leiste NICHT bewegt (sie ist
       position:fixed und damit ausserhalb des Layoutflusses) - sonst Endlos-Oszillation. */
    (function () {
      var hero = $('[data-riwi-lp2-hero]');
      if (!hero) return;
      var bar = $('[data-sticky-atc]', hero);
      if (!bar) return;
      var atc = $('[data-atc]', hero);
      if (!atc) { if (bar.parentNode) bar.parentNode.removeChild(bar); return; }

      /* Portal an <body> - wie bei der Lightbox: innerhalb der Section kann ein transform auf
         einem Vorfahren position:fixed an die Spalte binden statt an den Viewport. Der
         form="..."-Bezug des Buttons gilt dokumentweit und ueberlebt das Umhaengen. */
      var portal = document.createElement('div');
      portal.className = 'riwi-lp2 is-js riwi-lp2-portal riwi-lp2-sticky-portal';
      document.body.appendChild(portal);
      portal.appendChild(bar);

      var setEl = $('[data-sticky-set]', bar);
      var priceEl = $('[data-sticky-price]', bar);
      var labelEl = $('[data-sticky-label]', bar);
      var btn = $('[data-sticky-btn]', bar);

      /* Owner 03.09.2026: kein Breakpoint-Gate mehr. Die Leiste laeuft auf jeder Breite -
         wie in der LP1 - und die CSS liefert ab 980px nur eine andere Optik. Entschieden
         wird ausschliesslich ueber rect.top des Haupt-Buttons (+ Hysterese). */
      var SHOW_AT = -8;       /* Hysterese: zwischen -8 und +8 px bleibt der Zustand stehen */
      var HIDE_AT = 8;
      var HIDE_MS = 320;      /* etwas mehr als die 250-ms-Transition */
      var shown = false;
      var blocked = false;    /* Closing/Footer im Blick -> Leiste weg */
      var hideTimer = null;
      var pending = false;
      var raf = window.requestAnimationFrame ? window.requestAnimationFrame.bind(window)
                                             : function (fn) { return setTimeout(fn, 16); };

      /* ---- Support-Chat-Launcher ueber der Sticky-Leiste anheben, solange sie sichtbar ist.
         fixed-Widgets vs. Boden-CTAs sind EINE Ebene: die Hoehe der Leiste (+8px) geht in eine
         CSS-Var, ein globales CSS-Rule wendet sie per transform an (nur transform wirkt bei
         fremden fixed-Elementen zuverlaessig). Freshchat injiziert #fc_frame oft erst >6s nach
         Load - ein MutationObserver haette nichts zu beobachten - deshalb sucht ein begrenzter
         1-s-Ticker (max. 30x) danach und wendet den jeweils aktuellen Offset per JS mit
         !important nach, falls Freshchat selbst einen Inline-Transform setzt. */
      var CHAT_OFFSET_VAR = '--riwi-lp2-bottom-offset';
      var CHAT_SEL = '#riwi-chat-launcher, #fc_frame, .fc-widget-small, .fc-widget-normal';
      var chatOffsetPx = 0;

      function applyChatOffset() {
        var val = chatOffsetPx > 0 ? Math.round(chatOffsetPx) + 'px' : '0px';
        document.documentElement.style.setProperty(CHAT_OFFSET_VAR, val);
        var t = chatOffsetPx > 0 ? 'translateY(calc(-1 * ' + val + '))' : 'none';
        $$(CHAT_SEL).forEach(function (el) { if (el) el.style.setProperty('transform', t, 'important'); });
      }

      (function chatTicker() {
        var tries = 0;
        var timer = setInterval(function () {
          tries++;
          applyChatOffset();
          if ($('#fc_frame') || tries >= 30) clearInterval(timer);
        }, 1000);
      })();

      function show() {
        if (shown) return;
        shown = true;
        if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
        bar.hidden = false;
        bar.setAttribute('aria-hidden', 'false');
        void bar.offsetHeight;            /* Reflow: sonst fehlt der Startwert der Transition */
        bar.classList.add('is-visible');
        chatOffsetPx = bar.getBoundingClientRect().height + 8;
        applyChatOffset();
      }

      function hide() {
        if (!shown) return;
        shown = false;
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        chatOffsetPx = 0;
        applyChatOffset();
        if (hideTimer) clearTimeout(hideTimer);
        /* hidden erst NACH der Transition: es nimmt den Button aus der Tab-Reihenfolge,
           wuerde die Animation aber sofort abschneiden. */
        hideTimer = setTimeout(function () {
          hideTimer = null;
          if (!shown) bar.hidden = true;
        }, HIDE_MS);
      }

      function update() {
        if (blocked) { hide(); return; }
        var top = atc.getBoundingClientRect().top;
        if (!shown) { if (top < SHOW_AT) show(); }
        else if (top > HIDE_AT) { hide(); }
        else { chatOffsetPx = bar.getBoundingClientRect().height + 8; applyChatOffset(); }
      }

      function schedule() {
        if (pending) return;
        pending = true;
        raf(function () { pending = false; update(); });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(schedule, { threshold: [0, 1] }).observe(atc);

        /* Zweiter Observer: unten angekommen darf die Leiste den Schluss-CTA / den Footer
           nicht dauerhaft verdecken. */
        var stops = [];
        $$('.riwi-lp2 .closing').forEach(function (el) { stops.push(el); });
        var foot = document.querySelector('footer.footer') || document.querySelector('footer');
        if (foot && stops.indexOf(foot) < 0) stops.push(foot);
        if (stops.length) {
          var io2 = new IntersectionObserver(function (es) {
            es.forEach(function (e) { e.target.__lp2Stop = e.isIntersecting; });
            var any = false;
            stops.forEach(function (el) { if (el.__lp2Stop) any = true; });
            blocked = any;
            schedule();
          }, { threshold: 0 });
          stops.forEach(function (el) { io2.observe(el); });
        }
      }

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      window.addEventListener('orientationchange', schedule, { passive: true });

      /* Variantenwechsel: nur Spiegel-Texte, nie eine zweite Varianten-Wahrheit. Die
         Varianten-ID steckt im input[name=id] der Hero-Form, an der dieser Button haengt. */
      hero.addEventListener('riwi:lp2:variant', function (e) {
        var d = e.detail || {};
        if (setEl && d.name) setEl.textContent = d.name;
        if (priceEl && d.price) priceEl.textContent = d.price;
        if (!btn) return;
        var sold = d.available === 'false';
        btn.disabled = !!sold;
        btn.setAttribute('aria-disabled', sold ? 'true' : 'false');
        var txt = sold
          ? (atc.getAttribute('data-soldout-label') || 'Sold out')
          : (atc.getAttribute('data-add-label') || (labelEl ? labelEl.textContent : ''));
        if (labelEl && txt) labelEl.textContent = txt;
        if (txt) btn.setAttribute('aria-label', txt);
      });

      update();
    })();

    /* ---------------------------------------------------------------- Accordions */
    $$('.detail, .faq-item').forEach(function (item) {
      var b = item.querySelector('button');
      if (!b) return;
      b.addEventListener('click', function () {
        var open = item.classList.toggle('open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* ---------------------------------------------------------------- Reveal
       F56: threshold bezieht sich auf die ELEMENT-Hoehe, nicht auf den Viewport. Sektionen,
       die hoeher sind als der Bildschirm (Buybox mobil: 1677 px), erreichen threshold .1 nie
       - sie blieben bis zum ersten Scroll unsichtbar. Deshalb threshold 0 und stattdessen
       ein negativer unterer rootMargin: das Element muss ein Stueck WEIT GENUG herein
       gescrollt sein, gemessen am Viewport statt am Element.
       Das beobachtete Element wird durch seine eigene Wirkung bewegt (translateY 16px), es
       wird darum nach dem ersten Treffer sofort unobserved - so kann kein Flackern an der
       Schwelle entstehen.
       sweep(): alles, was schon im oder oberhalb des Viewports liegt, wird ohne Umweg ueber
       den Observer sichtbar (isIntersecting=false ist zweideutig - es heisst auch "liegt
       oberhalb"). Der Nachlauf nach 1500 ms faengt spaete Layout-Spruenge (Web-Fonts,
       nachgeladene Bilder) ab, damit nichts oben haengen bleibt; Sektionen WEITER UNTEN
       bleiben bewusst am Scroll-Trigger. */
    (function () {
      var els = $$('.riwi-lp2 .reveal');
      if (!els.length) return;
      var show = function (el) { el.classList.add('visible'); };
      if (!('IntersectionObserver' in window) || reduceMotion()) {
        els.forEach(show);
        return;
      }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
      var sweep = function () {
        var vh = window.innerHeight || document.documentElement.clientHeight;
        els.forEach(function (el) {
          if (el.classList.contains('visible')) return;
          if (el.getBoundingClientRect().top < vh) { show(el); io.unobserve(el); }
        });
      };
      els.forEach(function (el) { io.observe(el); });
      sweep();
      window.addEventListener('load', sweep, { once: true });
      setTimeout(sweep, 1500);
    })();

    /* ---------------------------------------------------------------- Voraussichtliche Lieferung
       Werktage (Sa/So ausgelassen), Spanne aus data-min / data-max des Ziel-Elements.

       ⚠️ C4 (18.09.2026): dasselbe Markup steht seit C4 auch im Warenkorb (gemeinsames
       Snippet snippets/riwi-atc-trust.liquid). Der Warenkorb laedt diese Datei NICHT und
       hat deshalb eine zweite Implementierung derselben Rechnung in
       assets/riwi-cart-contents.js (initEdd). Werktags-Regel oder Datumsformat nie nur
       hier aendern — sonst nennt der Warenkorb ein anderes Datum als die PDP. */
    $$('[data-edd], .riwi-lp2 #edd').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-edd-min'), 10) || 2;
      var max = parseInt(el.getAttribute('data-edd-max'), 10) || 5;
      if (!(min > 0) || !(max >= min)) return;
      var add = function (d, n) {
        var x = new Date(d.getTime()), c = 0;
        while (c < n) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) c++; }
        return x;
      };
      var fmt = function (d) {
        try { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
        catch (e) { return d.toDateString(); }
      };
      var now = new Date();
      el.textContent = fmt(add(now, min)) + ' – ' + fmt(add(now, max));
    });

    /* ---------------------------------------------------------------- Video-Testimonials
       Nur Poster im Initial-Load. Video-Bytes erst, wenn die Karte im Viewport ist, dann
       stumm autoplay; ausser Sicht -> pause. video.src DIREKT setzen (kein <source>-Nachtrag),
       sofort play() mit catch statt auf canplay zu warten (das waere ein Deadlock). */
    (function () {
      var cards = $$('.riwi-lp2 .vt');
      if (!cards.length) return;

      var ensure = function (f) {
        if (f._v) return f._v;
        var src = f.getAttribute('data-src');
        var poster = f.querySelector('img');
        if (!src || !poster) return null;
        var v = document.createElement('video');
        v.muted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        v.setAttribute('loop', '');
        v.loop = true;
        v.playsInline = true;
        v.preload = 'auto';
        v.poster = poster.currentSrc || poster.src;
        v.src = src;
        /* F22 (15.10.2026): das <video> kommt UEBER das Poster (Klasse vt-v, position absolute,
           unsichtbar) statt es zu ersetzen. Sichtbar wird es erst, wenn ein Frame da ist
           (playing/timeupdate/loadeddata) - bis dahin zeigt die Karte das Poster (= Frame 0),
           nie die schwarze Buehne. Gemessen in WebKit: vorher bis ~1,8 s Schwarz nach dem Swipe. */
        v.className = 'vt-v';
        var on = function () { v.classList.add('is-on'); };
        v.addEventListener('playing', on, { once: true });
        v.addEventListener('timeupdate', on, { once: true });
        v.addEventListener('loadeddata', on, { once: true });
        f.insertBefore(v, f.firstChild);
        f._v = v;
        return v;
      };
      var play = function (f) {
        var v = ensure(f);
        if (!v) return;
        var p = v.play();
        var mark = function () { f.classList.add('playing'); };
        if (p && p.then) p.then(mark).catch(function () {});
        else mark();
        v.addEventListener('timeupdate', mark, { once: true });
      };
      var pause = function (f) { if (f._v) { f._v.pause(); f.classList.remove('playing'); } };

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            e.target._inview = e.isIntersecting && e.intersectionRatio >= .5;
            if (e.target._inview) play(e.target); else pause(e.target);
          });
        }, { threshold: [0, .5], rootMargin: '0px 0px 120px 0px' });
        cards.forEach(function (f) { io.observe(f); });
      }
      cards.forEach(function (f) {
        f.addEventListener('mouseenter', function () { play(f); });
        f.addEventListener('mouseleave', function () { if (!f._inview) pause(f); });
        var btn = f.querySelector('.vt-play');
        if (btn) btn.addEventListener('click', function () { play(f); });
      });
    })();

    /* ---------------------------------------------------------------- Set-Finder-Slider */
    $$('[data-rv-track], .riwi-lp2 #rvTrack').forEach(function (tr) {
      var scope = tr.closest('.riwi-lp2') || document;
      var prev = scope.querySelector('[data-rv-prev]') || scope.querySelector('#rvPrev');
      var next = scope.querySelector('[data-rv-next]') || scope.querySelector('#rvNext');
      var step = function () {
        var first = tr.children[0];
        if (!first) return 300;
        return first.getBoundingClientRect().width + 18;
      };
      if (prev) prev.addEventListener('click', function () { tr.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { tr.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    });

    /* ---------------------------------------------------------------- FREE12 / Gratis-Set-Aktion
       Markup existiert NUR, wenn im Theme-Editor promo_active AN ist. Ohne [data-f12-box] macht
       dieses Modul nichts -> Promo aus = exakt heutiges Verhalten (keine Regression).
       Qualifiziert = Blockzahl der gewaehlten Variante >= data-f12-min. Bei aktiv+qualifiziert
       legen Haupt- UND Sticky-ATC Set + Gratis-12er per /cart/add.js in den Warenkorb, wenden den
       Code per /cart/update.js an (MERGE mit vorhandenen Cart-Codes, nie ueberschreiben) und gehen
       dann auf /cart. Nicht qualifiziert / inaktiv -> das native Formular laeuft unveraendert.
       Erfolg haengt an der Antwort, nie an einem Timer; Doppel-Adds fangen busy-Flag + capture-
       stopImmediatePropagation ab (product-form sieht keinen Submit). */
    (function () {
      var hero = $('[data-riwi-lp2-hero]');
      if (!hero) return;
      var box = $('[data-f12-box]', hero);
      if (!box) return;

      var MIN   = parseInt(box.getAttribute('data-f12-min'), 10) || 24;
      var EXTRA = parseInt(box.getAttribute('data-f12-extra'), 10) || 0;
      var CODE  = (box.getAttribute('data-f12-code') || '').trim();
      var SOLDOUT = parseInt(box.getAttribute('data-f12-soldout-blocks'), 10) || 0;
      /* S2 Black Month (27.10.2026): Bundle-Anker (Hero-Setting promo_anchor = bundle, nur Couch-
         Templates mit Umschalter zwischen zwei Produkten). Qualifiziert = Zustand B
         (hero[data-bundle-state="b"]) im Zeitfenster (data-cw-start/-end, Sekunden,
         snippets/riwi-campaign-window). Gleicher Kaufpfad; zusaetzlich dropIfCodeFails, damit nie
         ein bezahlter 12er als Geschenk liegen bleibt. Ohne data-f12-anchor exakt wie bisher. */
      var ANCHOR = box.getAttribute('data-f12-anchor') === 'bundle';
      var CW_S = parseInt(box.getAttribute('data-cw-start'), 10) || 0;
      var CW_E = parseInt(box.getAttribute('data-cw-end'), 10) || 0;
      var CW_FORCE = box.getAttribute('data-cw-force') === 'on';
      var TILE_F12 = ANCHOR ? hero.querySelector('[data-f12-tile]') : null;
      function windowOpen() {
        if (!ANCHOR) return true;
        if (CW_FORCE) return true;
        if (!(CW_S > 0 && CW_E > CW_S)) return false;
        var now = Date.now() / 1000;
        return now >= CW_S && now <= CW_E;
      }
      var onEl  = $('[data-f12-on]', box);
      var offEl = $('[data-f12-off]', box);
      var soldoutEl = $('[data-f12-soldout]', box);
      var stickyPromo = $('[data-sticky-promo]');   /* im Body-Portal -> dokumentweit suchen */
      var stickySoldout = $('[data-sticky-soldout]');
      var idInput = $('input[data-variant-id]', hero);
      var errWrap = $('.product-form__error-message-wrapper', hero);
      var errMsg  = errWrap ? $('.product-form__error-message', errWrap) : null;

      var busy = false;

      function blocksFromName(name) {
        if (!name) return 0;
        var n = parseInt(String(name).split(' ')[0], 10);
        return n > 0 ? n : 0;
      }
      function currentBlocks() {
        var active = $('.variant.active', hero);
        return active ? blocksFromName(active.getAttribute('data-name')) : 0;
      }
      function qualifying() {
        if (ANCHOR) return EXTRA > 0 && windowOpen() && hero.getAttribute('data-bundle-state') === 'b';
        return EXTRA > 0 && currentBlocks() >= MIN;
      }
      /* Dritter Zustand: die konfigurierte Soldout-Blockzahl ist gewaehlt UND qualifiziert
         nicht ueber MIN (ON hat Vorrang, falls beides je gleich konfiguriert waere). */
      function isSoldout() { return !ANCHOR && SOLDOUT > 0 && !qualifying() && currentBlocks() === SOLDOUT; }

      function setState(q, so) {
        if (ANCHOR) box.hidden = !q;   /* Bundle-Anker: ganze Box nur in Zustand B + Fenster (kein Leerraum in A) */
        if (ANCHOR && TILE_F12) TILE_F12.hidden = !windowOpen();   /* I1: Kachel-Badge (Bundle-Kachel) nur im Fenster, unabhaengig von A/B */
        if (onEl)  onEl.hidden  = !q;
        if (soldoutEl) soldoutEl.hidden = !so;
        if (offEl) offEl.hidden = q || so;
        if (stickyPromo) stickyPromo.hidden = !q;
        if (stickySoldout) stickySoldout.hidden = !so;
      }

      function showError(msg) {
        if (errMsg && errWrap) { errMsg.textContent = msg; errWrap.hidden = false; }
      }
      function clearError() {
        if (errWrap) { errWrap.hidden = true; if (errMsg) errMsg.textContent = ''; }
      }

      /* Warenkorb-Weg: EINE Stelle fuer die ganze LP (Cart oben in dieser Datei). Der frueher
         hier stehende eigene Block (mergeCodes/findEntry/postJson/cartRoot/cartUrl +
         promoAdd) war Schritt fuer Schritt dieselbe Abfolge - inklusive der Markt-Praefix-
         Regel B4 (04.09.2026): riwi-buildit.us fuehrt neben USD Kanada unter /en-ca/ und
         /fr-ca/ in CAD, eine unpraefixierte Cart-Route kippt den Warenkorb auf USD.
         Diese Regel lebt jetzt in Cart.root()/Cart.url() und gilt damit fuer ALLE Kaufpfade. */
      function promoAdd(btn) {
        if (busy) return;
        var setId = idInput && idInput.value ? parseInt(idInput.value, 10) : 0;
        if (!setId || !EXTRA) return;
        busy = true;
        clearError();
        var origDisabled = btn.disabled;
        btn.disabled = true; btn.setAttribute('aria-busy', 'true');
        var restore = function () { busy = false; btn.disabled = origDisabled; btn.removeAttribute('aria-busy'); };
        Cart.addAndApply({
          tag: 'riwi-lp2 free12',
          items: [{ id: setId, quantity: 1 }, { id: EXTRA, quantity: 1 }],
          codes: CODE ? [CODE] : [],
          dropIfCodeFails: (ANCHOR && CODE) ? [{ id: EXTRA, code: CODE }] : null,
          onError: function (msg) { restore(); showError(msg); },
          /* riwi-us-cart-redesign P2: oeffnet der Drawer statt zu navigieren, bleibt die
             Seite stehen -> busy/disabled muss HIER zurueckgenommen werden (sonst fuer
             immer "busy", weil kein pageshow mehr kommt). */
          onSuccess: restore
        });
      }

      /* ---- B3 (04.09.2026, portiert von der .com-LP2): Der Erfolgspfad laesst busy=true
         und btn.disabled=true stehen und navigiert (kein Doppel-Add waehrend des
         Seitenwechsels). Kommt der Kunde per ZURUECK aus dem bfcache, ist dieser Zustand
         eingefroren: der Button ist disabled + aria-busy, jeder Klick laeuft in
         `if (busy) return` -> der ATC wirkt TOT, ohne Konsolenfehler.
         Auf der .com reproduziert mit tools/cdp_back_button_probe.py.
         Zurueckgesetzt wird nur, was WIR markiert haben (aria-busy) - ein echt
         deaktivierter Button (ausverkauft) bleibt deaktiviert. */
      function releaseBusy() {
        busy = false;
        $$('[data-atc], [data-sticky-btn]').forEach(function (b) {
          if (b && b.getAttribute('aria-busy') === 'true') {
            b.disabled = false;
            b.removeAttribute('aria-busy');
          }
        });
      }
      window.addEventListener('pageshow', releaseBusy);

      function hook(btn) {
        if (!btn || btn.__f12hooked) return;
        btn.__f12hooked = true;
        btn.addEventListener('click', function (e) {
          /* Liegt ein Zubehoer-Haken an, uebernimmt der kombinierte Add-on-Pfad (Modul weiter
             unten, deshalb spaeter registriert und in der Capture-Phase nach diesem hier). Er
             fuehrt das Gratis-Set selbst mit. Ohne preventDefault aussteigen, sonst kaeme er
             gar nicht dran. */
          if (window.RiwiLp2Addons && window.RiwiLp2Addons.active()) return;
          if (busy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
          if (!qualifying()) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          promoAdd(btn);
        }, true);
      }

      hook($('[data-atc]', hero));
      hook($('[data-sticky-btn]'));

      hero.addEventListener('riwi:lp2:variant', function () { setState(qualifying(), isSoldout()); });
      setState(qualifying(), isSoldout());
      if (ANCHOR) {
        /* Umschalter A/B (auch Sticky-Set-Feld) setzt nur data-bundle-state - ohne riwi:lp2:variant. */
        if ('MutationObserver' in window) {
          new MutationObserver(function () { setState(qualifying(), isSoldout()); })
            .observe(hero, { attributes: true, attributeFilter: ['data-bundle-state'] });
        }
        /* Start/Ende waehrend die Seite offen ist (nur wenn < 24 Tage entfernt: setTimeout-Grenze). */
        [CW_S, CW_E + 1].forEach(function (t) {
          var ms = t * 1000 - Date.now();
          if (!CW_FORCE && ms > 0 && ms < 2147483000) {
            window.setTimeout(function () { setState(qualifying(), isSoldout()); }, ms);
          }
        });
      }
    })();

    /* ------------------------------------- Set-Karten mit Gratis-Zugabe (F37, 15.09.2026)
       Die Set-Karten posteten bisher ein nacktes Formular auf /cart/add: im Warenkorb lag
       dann NUR das Set - ohne die auf der Karte versprochene Zugabe und ohne Code. Dieses
       Modul faehrt stattdessen denselben Kaufpfad wie der Haupt-ATC: Set + Zugabe in EINEM
       cart/add.js, Codes per update.js zusammengefuehrt, und navigiert erst NACH der Antwort
       (Cart oben in dieser Datei - eine Stelle fuer alle Kaufwege dieser Seite, inklusive
       Markt-Praefix /en-ca/ und /fr-ca/).
       Zwei Zugaben, zwei Quellen, KEINE zweite Config-Wahrheit - beide Kaesten stehen in der
       Hero-Section und sind dort die einzige Wahrheit:
         data-set-gift="bag" -> [data-fb-box]:  Code, Blockzahl und die GEWAEHLTE Bag-Farbe
                                (waehlt der Kunde oben eine andere Farbe, bekommt er genau die)
         data-set-gift="f12" -> [data-f12-box]: Code, Mindest-Blockzahl und Gratis-Variante
       Fehlt der zugehoerige Kasten (Aktion aus), wird diese Karte nicht uebernommen und ihr
       natives Formular laeuft unveraendert - nie eine Zusage einloesen wollen, deren Aktion
       gar nicht laeuft.
       Markup-Gate: die Section setzt data-set-gift-form nur, wenn der Owner den Kaufpfad
       eingeschaltet hat - ohne dieses Attribut ist das Modul stumm (die .com laedt dieselbe
       Datei). */
    (function () {
      var forms = $$('[data-set-gift-form]');
      if (!forms.length) return;
      /* Ohne fetch waere jede Uebernahme eine Luege - dann lieber das native Formular. */
      if (typeof window.fetch !== 'function') return;

      var fbBox = $('[data-fb-box]');
      var f12Box = $('[data-f12-box]');

      var BAG = fbBox ? {
        code: (fbBox.getAttribute('data-fb-code') || '').trim(),
        blocks: parseInt(fbBox.getAttribute('data-fb-blocks'), 10) || 0
      } : null;
      var F12 = f12Box ? {
        code: (f12Box.getAttribute('data-f12-code') || '').trim(),
        min: parseInt(f12Box.getAttribute('data-f12-min'), 10) || 0,
        extra: parseInt(f12Box.getAttribute('data-f12-extra'), 10) || 0
      } : null;

      /* Die Farbwahl der Hero-Box ist immer belegt (serverseitig vorgewaehlt); der Fallback
         auf den ersten Swatch ist nur das Netz, falls jemand das aria-checked entfernt. */
      function bagVariantId() {
        var sw = $('[data-fb-swatch][aria-checked="true"]', fbBox) || $('[data-fb-swatch]', fbBox);
        return sw ? (parseInt(sw.getAttribute('data-variant-id'), 10) || 0) : 0;
      }

      /* Die Zugabe dieser Karte als { code, id } - oder null, dann laeuft das native
         Formular. Die Blockzahl-Pruefung ist Absicht: ein BXGY-Code verankert genau die
         Mengen aus customerBuys, und die Wahrheit darueber steht in der Hero-Box, nicht in
         den Section-Settings. Weichen beide ab (Fehlkonfiguration), wird nichts uebernommen. */
      function giftFor(kind, blocks) {
        if (kind === 'bag') {
          if (!BAG || !BAG.code || !BAG.blocks || blocks !== BAG.blocks) return null;
          var bagId = bagVariantId();
          return bagId ? { code: BAG.code, id: bagId } : null;
        }
        if (kind === 'f12') {
          if (!F12 || !F12.code || !F12.min || !F12.extra || blocks < F12.min) return null;
          return { code: F12.code, id: F12.extra };
        }
        return null;
      }

      var busy = false;

      forms.forEach(function (form) {
        var kind = (form.getAttribute('data-set-gift') || '').trim();
        var blocks = parseInt(form.getAttribute('data-set-gift-blocks'), 10) || 0;
        if (!kind || !blocks) return;

        var idInput = $('input[name="id"]', form);
        var btn = $('button[type="submit"]', form);
        var err = $('[data-set-err]', form.parentNode || document);

        function showError(msg) {
          if (!err) return;
          err.textContent = msg;
          err.hidden = false;
        }

        /* submit statt click: faengt auch die Tastatur-Bedienung (Enter im Formular). Die
           A/B-Messung haengt an einem click-Listener am document und laeuft davon unberuehrt
           weiter. */
        form.addEventListener('submit', function (e) {
          var setId = idInput && idInput.value ? parseInt(idInput.value, 10) : 0;
          var gift = giftFor(kind, blocks);
          if (!setId || !gift) return;       /* ohne Set-ID oder Zugabe: natives Formular */
          e.preventDefault();
          if (busy) return;
          busy = true;
          if (err) { err.hidden = true; err.textContent = ''; }
          var wasDisabled = btn ? btn.disabled : false;
          if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
          Cart.addAndApply({
            tag: 'riwi-lp2 sets ' + kind,
            items: [{ id: setId, quantity: 1 }, { id: gift.id, quantity: 1 }],
            codes: [gift.code],
            /* Greift der Code nicht, darf die Zugabe nicht als bezahlte Position liegenbleiben. */
            dropIfCodeFails: [{ id: gift.id, code: gift.code }],
            onError: function (msg) {
              busy = false;
              if (btn) { btn.disabled = wasDisabled; btn.removeAttribute('aria-busy'); }
              showError(msg);
            },
            /* riwi-us-cart-redesign P2: s. promoAdd oben — ohne Navigation muss der Button
               selbst zurueckgenommen werden. */
            onSuccess: function () {
              busy = false;
              if (btn) { btn.disabled = wasDisabled; btn.removeAttribute('aria-busy'); }
            }
          });
        });
      });

      /* bfcache: der Erfolgspfad navigiert mit busy/disabled. Nach dem Zurueck-Button waere
         der Button sonst eingefroren und wirkte tot (dieselbe Falle wie im f12- und im
         FREEBAG-Modul). Zurueckgesetzt wird nur, was WIR markiert haben. */
      window.addEventListener('pageshow', function () {
        busy = false;
        forms.forEach(function (form) {
          var b = $('button[type="submit"]', form);
          if (b && b.getAttribute('aria-busy') === 'true') {
            b.disabled = false;
            b.removeAttribute('aria-busy');
          }
        });
      });
    })();

    /* ------------------------------------------------------- Zubehoer-Add-ons (Bag / Couch)
       F2 (Owner 17.09.2026): Dieses Modul ist nach assets/riwi-lp2-addons.js umgezogen — der
       Warenkorb (Cart-Drawer + /cart) zeigt seit F2 GENAU denselben Block, und der Drawer wird
       sitewide gerendert; er darf dafuer nicht diese 122-KB-Datei laden. riwi-lp2-head.liquid
       laedt die kleine Datei mit `defer` NACH dieser hier, sie haengt sich also erst danach ein.
       Fuer die beiden Wachen unten aendert das nichts: sie fragen window.RiwiLp2Addons zur
       KLICK-Zeit (Zeile "if (window.RiwiLp2Addons ...) return"), nicht zur Registrierungszeit. */

    /* ---------------------------------------------------------- A2: Mengenwaehler (Bag-Staffel)
       Nur mit qty_picker=stepper (Farbmodus) im DOM - ohne [data-hero-qty] tut dieses Modul
       nichts, also byte-/verhaltensidentisch fuer alle anderen Seiten (Couch ohne Stepper,
       Bausteine-PDP, Landingpage). Die Menge geht in [name=quantity] der EINEN Kaufform -
       Haupt- UND Sticky-Button haengen ueber form="..." an genau diesem Feld, kein zweiter
       Zaehler. Preis- und Ersparnis-Anzeige kommen als fertige money-Strings vom Server
       (data-price-q/data-save-q je Farbfeld, s. Hero-Section) und werden hier nur getauscht,
       nie berechnet.
       Vorrang mit dem Zubehoer-Modul: existiert window.RiwiLp2Addons (Add-ons ueberhaupt
       gerendert), uebernimmt DESSEN combinedAdd() jeden Fall - Haken UND/ODER Staffel-Code
       (dort gepatcht, s. o.); dasselbe Muster wie die FREE12-Box. Nur OHNE Zubehoer-Modul baut
       dieses hier selbst EIN cart/add.js aus Hauptprodukt x Menge + Staffel-Code. */
    (function () {
      var hero = $('[data-riwi-lp2-hero]');
      if (!hero) return;
      var root = $('[data-hero-qty]', hero);
      if (!root) return;
      var idInput = $('input[data-variant-id]', hero);
      var priceEl = $('[data-price]', hero);
      var stepWrap = $('[data-hero-step]', root);
      var numEl = $('[data-hero-step-n]', root);
      var stepBtns = $$('[data-hero-step-d]', root);
      var chipEl = $('[data-hero-qty-save]', root);
      var errWrap = $('.product-form__error-message-wrapper', hero);
      var errMsg = errWrap ? $('.product-form__error-message', errWrap) : null;
      var MAX = parseInt(stepWrap ? stepWrap.getAttribute('data-ao-step-max') : '', 10) || 4;
      if (MAX < 1) MAX = 1;
      var busy = false;

      function parseMap(str) {
        var out = {};
        (str || '').split('|').forEach(function (pair) {
          if (!pair) return;
          var i = pair.indexOf(':');
          if (i < 1) return;
          out[pair.slice(0, i)] = pair.slice(i + 1);
        });
        return out;
      }
      /* qn -> {code, pct}. parseMap trennt nur am ERSTEN Doppelpunkt, der Wert ist also noch
         "CODE:PCT" und wird hier ein zweites Mal zerlegt. */
      var TIERS = {};
      var rawTiers = parseMap(root.getAttribute('data-qty-map'));
      for (var tk in rawTiers) {
        if (!Object.prototype.hasOwnProperty.call(rawTiers, tk)) continue;
        var tf = rawTiers[tk].split(':');
        TIERS[tk] = { code: tf[0] || '', pct: tf[1] || '' };
      }
      var TPL = root.getAttribute('data-qty-tpl') || '';

      var qty = 1;
      function activeSwatch() { return $('.variant.active[data-cv-swatch]', hero); }
      function tierFor(n) { return TIERS[String(n)] || null; }

      /* Preis + Ersparnis-Chip fuer die AKTUELLE Farbe und Menge - laeuft bei JEDEM
         riwi:lp2:variant, nicht nur beim Stepper-Klick: ein Farbwechsel bei Menge > 1 (oder
         eine Nachwahl durch den Bestandsfilter) muss dieselbe Summe zeigen. EINE Quelle fuer
         die Anzeige, kein zweiter Rechenweg. */
      function paintPrice() {
        var active = activeSwatch();
        if (!active) return;
        var priceQ = parseMap(active.getAttribute('data-price-q'));
        var saveQ = parseMap(active.getAttribute('data-save-q'));
        var total = priceQ[String(qty)];
        if (total) {
          if (priceEl) priceEl.textContent = total;
          /* Sticky-Leiste haengt im Body-Portal - dokumentweit suchen, wie ueberall sonst. */
          var stickyPriceEl = document.querySelector('[data-sticky-price]');
          if (stickyPriceEl) stickyPriceEl.textContent = total;
        }
        if (!chipEl) return;
        var tier = tierFor(qty);
        var saveTxt = saveQ[String(qty)];
        if (tier && saveTxt && TPL) {
          chipEl.textContent = TPL
            .replace('{qty}', String(qty))
            .replace('{pct}', tier.pct)
            .replace('{total}', saveTxt);
          chipEl.hidden = false;
        } else {
          chipEl.hidden = true;
        }
      }
      hero.addEventListener('riwi:lp2:variant', paintPrice);

      function paintStep() {
        if (numEl) numEl.textContent = String(qty);
        stepBtns.forEach(function (b) {
          var d = parseInt(b.getAttribute('data-hero-step-d'), 10) || 0;
          b.disabled = (d < 0 && qty <= 1) || (d > 0 && qty >= MAX);
        });
      }

      function setQty(n) {
        if (!(n >= 1)) n = 1;
        if (n > MAX) n = MAX;
        if (n === qty) return;
        qty = n;
        if (idInput && idInput.form) {
          var qEl = idInput.form.querySelector('[name="quantity"]');
          if (qEl) qEl.value = String(qty);
        }
        paintStep();
        /* riwi:lp2:variant mit dem dataset der AKTIVEN Farbe - dieselbe Form, die
           selectTile() beim Klick verschickt: Sticky-Leiste, Zubehoer-Festbetrag
           (anchorQty() liest [name=quantity] neu) und paintPrice() ziehen darueber mit,
           kein zweiter Aufruf je Spiegel. CustomEvent.detail aus dataset = Strings. */
        var active = activeSwatch();
        try {
          hero.dispatchEvent(new CustomEvent('riwi:lp2:variant', { detail: active ? active.dataset : {} }));
        } catch (e) { paintPrice(); }
        /* Bestandsfilter neu pruefen: dieselbe gebuendelte Storefront-Abfrage, nur mit der
           NEUEN Menge als Schwelle (der Listener dafuer liest sie aus [name=quantity]). */
        try { hero.dispatchEvent(new CustomEvent('riwi:lp2:stock', { detail: {} })); }
        catch (e) { /* Bestandsfilter bleibt beim aktuellen Stand */ }
      }

      stepBtns.forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          setQty(qty + (parseInt(b.getAttribute('data-hero-step-d'), 10) || 0));
        });
      });

      function showError(msg) { if (errMsg && errWrap) { errMsg.textContent = msg; errWrap.hidden = false; } }
      function clearError() { if (errWrap) { errWrap.hidden = true; if (errMsg) errMsg.textContent = ''; } }

      /* ---- ATC ohne Zubehoer-Modul: EIN cart/add.js aus Hauptprodukt x Menge + Staffel-Code. */
      function ownAdd(btn) {
        if (busy) return;
        var tier = tierFor(qty);
        var code = tier ? tier.code : '';
        var vid = idInput ? (parseInt(idInput.value, 10) || 0) : 0;
        if (!code || !vid) return;
        busy = true;
        clearError();
        var wasDisabled = btn.disabled;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        var release = function () { busy = false; btn.disabled = wasDisabled; btn.removeAttribute('aria-busy'); };
        Cart.addAndApply({
          tag: 'riwi-lp2 qty-staffel',
          items: [{ id: vid, quantity: qty }],
          codes: [code],
          onError: function (msg) { release(); showError(msg); },
          /* N2-Fix (16.09.2026): fehlte als einziger Cart.addAndApply-Aufrufer. Mit Drawer
             bleibt die Seite stehen -> ohne onSuccess waere der Button danach dauerhaft
             busy/disabled (kein pageshow, weil kein Seitenwechsel). */
          onSuccess: release
        });
      }

      function hook(btn) {
        if (!btn || btn.__heroQtyHooked) return;
        btn.__heroQtyHooked = true;
        btn.addEventListener('click', function (e) {
          /* Zubehoer-Modul (falls vorhanden) hat Vorrang - es fuehrt Staffel-Code UND
             Set-Code in EINEM Aufruf (s. Patch combinedAdd weiter oben). */
          if (window.RiwiLp2Addons) return;
          var tier = tierFor(qty);
          if (!tier || !tier.code) return;
          if (typeof window.fetch !== 'function') return;
          if (busy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
          e.preventDefault();
          e.stopImmediatePropagation();
          ownAdd(btn);
        }, true);
      }
      hook($('[data-atc]', hero));
      hook($('[data-sticky-btn]'));

      paintStep();
      paintPrice();
    })();

    /* ------------------------------------ FAM-2: Umschalter "nur Bezug" / "Bezug + Set"
       Ohne [data-bundle-toggle] im DOM tut dieses Modul NICHTS - Landingpage, Bausteine-PDP
       und jede Farbseite ohne den Schalter laufen unveraendert.

       ES GIBT KEINEN ZWEITEN KAUFWEG. Zustand B setzt den Haken der bereits vorhandenen
       Zubehoer-Zeile (dieselbe Set-Variante) und blendet sie per data-bundle-state aus. Den
       Warenkorb baut danach GENAU DIE combinedAdd() aus assets/riwi-lp2-addons.js, die den
       Fall heute schon faehrt: EIN cart/add.js mit Bezug + Set und ein cart/update.js mit dem
       Festbetrags-Code (Stueckzahl-Code vor Preisstufen-Code) plus, bei der Bag, dem
       Mengenstaffel-Code. Deshalb registriert dieses Modul KEINEN Klick-Handler auf dem
       Kaufbutton - es gaebe sonst zwei Zustaendige fuer denselben Klick.
       Findet sich die Zubehoer-Zeile nicht (Fehlkonfiguration, die Liquid eigentlich
       abfaengt), verschwindet der Umschalter: lieber kein Angebot als eines ohne Kaufweg.

       Das Preis-Malen haengt an riwi:lp2:variant und ist bewusst NACH dem Mengenwaehler
       registriert (Modul direkt darueber): beide schreiben in [data-price], und bei gleichem
       Ereignis gewinnt der zuletzt registrierte Hoerer. Gerechnet wird hier nichts - alle
       Betraege sind fertige money-Strings vom Server (data-bundle-*-Karten am Farbfeld). */
    /* ------------------------------ F7-F10 (Owner 14.10.2026): Umschalter ZWISCHEN ZWEI PRODUKTEN
       Nur mit [data-bundle-mechanic="product"] im DOM (Hero-Setting bundle_mechanic = product,
       heute nur die Couch-PDP) - sonst tut dieses Modul NICHTS und das FAM-2-Modul darunter
       laeuft wie bisher.
       Zustand B = Bundle-Produkt (Shopify Bundles, eine Variante je Farbe), Zustand A = dieses
       Produkt. Gewechselt wird ausschliesslich die ID im EINEN Formularfeld
       input[data-variant-id] (Typ-gescopter Selektor, Hotfix-Lektion 16.09.) - den Warenkorb
       legt danach der vorhandene Kaufpfad an (plain-ATC bzw. natives Formular). Kein eigener
       Klick-Handler, kein zweiter Kaufweg, kein Rabattcode.
       Farbwechsel laufen weiter durch selectTile() (setzt Preis/ID/Bild auf den Bezug) - dieser
       Hoerer haengt danach an riwi:lp2:variant und legt in Zustand B die Werte der
       Bundle-Variante DERSELBEN Farbe darueber. Alle Betraege sind fertige money-Strings vom
       Server (data-bp-* am Farbfeld). */
    (function () {
      var hero = $('[data-riwi-lp2-hero]');
      if (!hero) return;
      var root = $('[data-bundle-toggle][data-bundle-mechanic="product"]', hero);
      if (!root) return;
      var segs = $$('[data-bundle-seg]', root);
      if (segs.length < 2) return;

      var START = root.getAttribute('data-bundle-default') === 'b' ? 'b' : 'a';
      var FB_IMG = root.getAttribute('data-bp-fallback-image') || '';
      var FB_SET = root.getAttribute('data-bp-fallback-srcset') || '';
      var priceEl = $('[data-price]', hero);
      var oldEl = $('[data-old-price]', hero);
      var idInput = $('input[data-variant-id]', hero);
      var atc = $('[data-atc]', hero);
      var atcLabel = atc ? $('[data-atc-label]', atc) : null;
      var mainImage = $('[data-main-image]', hero);
      var incl = $('[data-bundle-incl]', hero);
      var inclText = incl ? $('[data-incl-text]', incl) : null;
      var inclNote = incl ? $('[data-incl-note]', incl) : null;
      var tile = {
        a: { p: $('[data-bundle-tile-price="a"]', root), o: $('[data-bundle-tile-old="a"]', root) },
        b: { p: $('[data-bundle-tile-price="b"]', root), o: $('[data-bundle-tile-old="b"]', root) }
      };
      var state = START;
      var imgSwapped = false;
      /* T4b (Owner 25.10.2026): Zustand + Farbe stehen in der Adresszeile - jeder Wechsel (Umschalter,
         Farbe, Sticky) schreibt per replaceState set=couch|covers + variant=<ID passend zum Zustand>.
         Komplett: auf der Bundle-Seite (data-rb-mirror) die Bundle-Variante, sonst die Bezugs-ID wie
         bisher; Bezuege: immer die Bezugs-Variante. Neuladen/Teilen zeigt so exakt Zustand + Farbe.
         Erst NACH dem Start aktiv (URL_ON): ohne Parameter bleibt die Adresse sauber und die
         Vorauswahl je Seite (Template-Setting bundle_default) unveraendert. Nur dieses Modul
         (Umschalter zwischen zwei Produkten = Couch-Templates + Spiegel) - andere Seiten nie. */
      var MIRROR = hero.getAttribute('data-rb-mirror') === '1';
      var URL_ON = false;
      /* riwi-us-bag-lp2 P2 (02.11.2026): Namen fuer ?set= je Seite aus der Section riwi-lp2-pdp-cfg
         (JSON-Block [data-riwi-lp2-pdp-cfg], z. B. Bag-Seiten bag|pouf). Ohne Block oder bei
         ungueltigen Werten bleibt covers|couch - die Couch-Seiten verhalten sich unveraendert. */
      var SET_A = 'covers', SET_B = 'couch';
      try {
        var cfgEl = document.querySelector('script[data-riwi-lp2-pdp-cfg]');
        var cfg = cfgEl ? JSON.parse(cfgEl.textContent || '{}') : null;
        var okSet = function (x) { return typeof x === 'string' && /^[a-z0-9-]{1,24}$/.test(x); };
        if (cfg && okSet(cfg.set_a) && okSet(cfg.set_b) && cfg.set_a !== cfg.set_b) { SET_A = cfg.set_a; SET_B = cfg.set_b; }
      } catch (e) { /* kaputter Block: Default bleibt */ }
      function syncUrl() {
        if (!URL_ON || !window.history || !window.history.replaceState) return;
        var sw = activeSwatch();
        if (!sw) return;
        var vid = (state === 'b' && MIRROR) ? sw.getAttribute('data-bp-id') : sw.getAttribute('data-id');
        if (!vid) return;
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('set', state === 'b' ? SET_B : SET_A);
          u.searchParams.set('variant', vid);
          window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
        } catch (e) { /* alter Browser: Auswahl funktioniert, nur die URL bleibt stehen */ }
      }

      function activeSwatch() { return $('.variant.active', hero); }
      function setText(el, txt) { if (el) { el.textContent = txt || ''; el.hidden = !txt; } }
      function sticky(txt) {
        var st = document.querySelector('[data-sticky-price]');
        if (st && txt) st.textContent = txt;
      }
      function setAvail(ok) {
        if (!atc) return;
        atc.disabled = !ok;
        atc.setAttribute('aria-disabled', ok ? 'false' : 'true');
        if (atcLabel) {
          atcLabel.textContent = ok
            ? (atc.getAttribute('data-add-label') || atcLabel.textContent)
            : (atc.getAttribute('data-soldout-label') || 'Sold out');
        }
        var sb = document.querySelector('[data-sticky-btn]');
        if (sb) sb.disabled = !ok;
      }
      /* Bild NUR direkt am Hauptbild tauschen (src + srcset gemeinsam, sonst waehlt der
         Browser weiter aus dem alten Kandidatensatz). Zurueck auf A uebernimmt selectTile()
         der aktiven Farbe - derselbe Galerie-Pfad wie bei jedem Farbklick. */
      function swapMain(src, set) {
        if (!mainImage || !src) return;
        if (set) mainImage.setAttribute('srcset', set); else mainImage.removeAttribute('srcset');
        mainImage.setAttribute('src', src);
        mainImage.setAttribute('data-full', src);
        imgSwapped = true;
      }

      function paintTiles(sw) {
        if (!sw) return;
        setText(tile.a.p, sw.getAttribute('data-price') || '');
        setText(tile.a.o, sw.getAttribute('data-old') || '');
        setText(tile.b.p, sw.getAttribute('data-bp-price') || '');
        setText(tile.b.o, sw.getAttribute('data-bp-old') || '');
      }

      /* F34 (Owner 15.10.2026): Kachelbilder vorladen - exakt die URLs/srcset-Kandidaten des
         Swaps (gleiche sizes wie die Kachel -> der Browser waehlt denselben Kandidaten, Cache-Hit).
         Nur Kachelgroesse, erst nach load/idle (kein Einfluss auf LCP). */
      var preDone = {};
      function tileImg(k) { var b = $('[data-tile-img="' + k + '"]', root); return b ? b.querySelector('img') : null; }
      function makeImg(k, u, ss) {
        var im = new Image(), t = tileImg(k);
        if (t && t.getAttribute('sizes')) im.sizes = t.getAttribute('sizes');
        if (ss) im.srcset = ss;
        im.src = u;
        return im;
      }
      /* Titelbild (Farb-Slot der Galerie) je Option: dieselbe URL/srcset + sizes des Hauptbilds wie
         im Swap (gallery swap() nutzt img.sizes) -> der Browser waehlt denselben Kandidaten passend
         zum devicePixelRatio. fetchpriority low, erst nach load/idle. */
      function mainSrc(sw, k) {
        return k === 'b' ? [sw.getAttribute('data-bp-image') || '', sw.getAttribute('data-bp-srcset') || '']
                         : [sw.getAttribute('data-cs-a') || '', sw.getAttribute('data-cs-a-ss') || ''];
      }
      function makeMain(u, ss) {
        var im = new Image();
        try { im.fetchPriority = 'low'; } catch (e) { /* alter Browser */ }
        if (mainImage && mainImage.getAttribute('sizes')) im.sizes = mainImage.getAttribute('sizes');
        if (ss) im.srcset = ss;
        im.src = u;
        return im;
      }
      /* Gate 5 H1: bei Datensparmodus oder 2G gar nicht vorladen. */
      var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      var noPreload = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
      function preTile(sw) {
        if (!sw || noPreload) return;
        ['a', 'b'].forEach(function (k) {
          var u = sw.getAttribute('data-t' + k);
          if (u && !preDone[u]) preDone[u] = makeImg(k, u, sw.getAttribute('data-t' + k + '-ss'));
          var m = mainSrc(sw, k);
          if (m[0] && !preDone[m[0]]) preDone[m[0]] = makeMain(m[0], m[1]);
        });
      }
      /* T6 (Owner 25.10.2026): Farbwahl-Bilder folgen dem Zustand - nur mit data-cpl. B = Komplett-Kachelbild
         der Farbe (data-tb, Breite aus dem eigenen srcset), A = Server-Bild (data-sa/-sa1, sonst beim ersten
         Wechsel gemerkt). */
      var CPL = hero.hasAttribute('data-cpl');
      function cplPicker() {
        if (!CPL) return;
        $$('[data-cv-swatch]', hero).forEach(function (b) {
          var im = $('.sw-img img', b), tb = b.getAttribute('data-tb');
          /* T7: data-tbk = Farbe behaelt ihr Bezug-Bild (Hero-Setting picker_b_keep), kein Couch-Bild fremder Farbe. */
          if (!im || !tb || b.hasAttribute('data-tbk')) return;
          var ws = (im.getAttribute('srcset') || '').split(',').map(function (x) { return (x.trim().split(/\s+/)[1] || '').replace('w', ''); });
          if (ws.length < 2 || !ws[0] || !ws[1]) return;
          if (!im.hasAttribute('data-sa')) { im.setAttribute('data-sa', im.getAttribute('src') || ''); im.setAttribute('data-sa1', (im.getAttribute('srcset') || '').trim().split(/\s+/)[0]); }
          var rw = function (w) { return /[?&]width=\d+/.test(tb) ? tb.replace(/([?&])width=\d+/, '$1width=' + w) : tb + (tb.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; };
          var s2 = state === 'b' ? rw(ws[1]) : im.getAttribute('data-sa'), s1 = state === 'b' ? rw(ws[0]) : im.getAttribute('data-sa1');
          if (!s2 || !s1 || im.getAttribute('src') === s2) return;
          im.setAttribute('srcset', s1 + ' ' + ws[0] + 'w, ' + s2 + ' ' + ws[1] + 'w');
          im.setAttribute('src', s2);
        });
      }
      hero.addEventListener('riwi:lp2:stock', function () { soAria(); });
      /* aria-label der markierten Cord-Hauptfarben folgt dem Zustand (A = Bezug, B = Bundle-Variante);
         Server-Render = Startzustand, gleicher Text wie das Badge (" – " + Kleinschreibung). */
      function soAria() {
        if (!CPL) return;
        $$('[data-sok]', hero).forEach(function (b) {
          var t = $('.sw-so', b), al = b.getAttribute('aria-label') || '';
          if (!t) return;
          var sfx = ' – ' + t.textContent.toLowerCase();
          if (al.slice(-sfx.length) === sfx) al = al.slice(0, -sfx.length);
          var so = state === 'b' ? (b.getAttribute('data-bp-available') === 'false' && !!b.getAttribute('data-bp-id'))
                                 : b.getAttribute('data-available') === 'false';
          b.setAttribute('aria-label', so ? al + sfx : al);
          /* Sticky-Leiste: dieselbe Farbe traegt denselben Zusatz (Option per Varianten-ID). */
          var sel = $('[data-sticky-select]', hero) || document.querySelector('[data-sticky-select]');
          var o = sel ? sel.querySelector('option[value="' + b.getAttribute('data-id') + '"]') : null;
          if (o) {
            var ot = o.textContent;
            if (ot.slice(-sfx.length) === sfx) ot = ot.slice(0, -sfx.length);
            ot = so ? ot + sfx : ot;
            if (o.textContent !== ot) o.textContent = ot;
          }
        });
        swSort();
      }
      /* T6 (Owner 03.11.2026): je Farbgruppe lieferbare zuerst, ausverkaufte ans Gruppenende - nach dem
         AKTIVEN Zustand (A = Bezug/Bag data-available, B = Bundle-Variante data-bp-available). Sonst gilt die
         Server-Reihenfolge (data-ix = Position der Variante). Server rendert schon nach dem Startzustand; hier
         wird nur bei Zustandswechsel/Bestandsfilter umgehaengt. Sticky-Optionen folgen derselben Reihenfolge. */
      function swSort() {
        var sws = $$('[data-cv-swatch][data-ix]', hero);
        if (!sws.length) return;
        var soOf = function (b) {
          return state === 'b' ? (b.getAttribute('data-bp-available') === 'false' && !!b.getAttribute('data-bp-id'))
                               : b.getAttribute('data-available') === 'false';
        };
        var groups = [], moved = false;
        sws.forEach(function (b) { if (groups.indexOf(b.parentNode) < 0) groups.push(b.parentNode); });
        groups.forEach(function (g) {
          var list = sws.filter(function (b) { return b.parentNode === g; });
          var want = list.slice().sort(function (x, y) {
            return ((soOf(x) ? 1 : 0) - (soOf(y) ? 1 : 0)) || (+x.getAttribute('data-ix') - +y.getAttribute('data-ix'));
          });
          if (!want.some(function (b, i) { return b !== list[i]; })) return;
          var fo = document.activeElement, anchor = list[list.length - 1].nextSibling;
          want.forEach(function (b) { g.insertBefore(b, anchor); });
          if (fo && fo !== document.activeElement && fo.focus) fo.focus();
          moved = true;
        });
        if (!moved) return;
        var sel = $('[data-sticky-select]', hero) || document.querySelector('[data-sticky-select]');
        if (!sel) return;
        var rk = {};
        $$('[data-cv-swatch]', hero).forEach(function (b, i) { rk[b.getAttribute('data-id')] = i; });
        var pars = [];
        Array.prototype.forEach.call(sel.options, function (o) { if (pars.indexOf(o.parentNode) < 0) pars.push(o.parentNode); });
        pars.forEach(function (p) {
          var os = Array.prototype.filter.call(p.children, function (o) { return o.tagName === 'OPTION'; });
          var r = function (o) { return rk[o.value] == null ? 1e4 : rk[o.value]; };
          var w = os.slice().sort(function (x, y) { return r(x) - r(y); });
          if (!w.some(function (o, i) { return o !== os[i]; })) return;
          var val = sel.value;
          w.forEach(function (o) { p.appendChild(o); });
          sel.value = val;
        });
      }
      var swapSeq = 0;
      function swapTiles(sw) {
        var jobs = [];
        ['a', 'b'].forEach(function (k) {
          var im = tileImg(k), u = sw.getAttribute('data-t' + k), ss = sw.getAttribute('data-t' + k + '-ss');
          if (!im || !u || im.getAttribute('src') === u) return;
          var pre = preDone[u] || (preDone[u] = makeImg(k, u, ss));
          jobs.push({ im: im, u: u, ss: ss, pre: pre });
        });
        /* Gate 5 B1: Token vor jedem Early-Return erhoehen (entwertet laufende Vor-Swaps). */
        var token = ++swapSeq;
        if (!jobs.length) return;
        /* gekoppelt: auch auf das Titelbild der Farbe/Option warten (gleiches Timeout) */
        var mk = mainSrc(sw, state), mp = mk[0] ? (preDone[mk[0]] || (preDone[mk[0]] = makeMain(mk[0], mk[1]))) : null;
        var pres = jobs.map(function (j) { return j.pre; });
        if (mp) pres.push(mp);
        var dec = Promise.all(pres.map(function (p) {
          return p.decode ? p.decode().catch(function () {}) : Promise.resolve();
        }));
        var apply = function () {
          if (token !== swapSeq) return;
          token = -1;
          jobs.forEach(function (j) {
            if (j.ss) j.im.setAttribute('srcset', j.ss); else j.im.removeAttribute('srcset');
            j.im.setAttribute('src', j.u);
          });
        };
        Promise.race([dec, new Promise(function (r) { setTimeout(r, 300); })]).then(apply);
      }
      (function () {
        var feat = $$('[data-sw-group="f"] [data-cv-swatch]', hero);
        if (!feat.length) feat = $$('[data-cv-swatch]', hero);
        var idle = function () { feat.forEach(preTile); };
        var later = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 1200); })(idle, { timeout: 3000 }); };
        if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
        /* Gate 5: kein Sammel-Preload beim Aufklappen von "More colors" (mobil ~889 kB) -
           Auslauffarben laden nur noch einzeln bei Hover/Touch/Fokus. */
        $$('[data-cv-swatch]', hero).forEach(function (b) {
          var f = function () { preTile(b); };
          b.addEventListener('pointerenter', f, { passive: true });
          b.addEventListener('touchstart', f, { passive: true });
          b.addEventListener('focus', f);
        });
      })();

      function paint() {
        var sw = activeSwatch();
        if (!sw) return;
        paintTiles(sw);
        var bpOk = sw.getAttribute('data-bp-available') === 'true' && !!sw.getAttribute('data-bp-id');
        if (state === 'b') {
          if (idInput && bpOk) idInput.value = sw.getAttribute('data-bp-id');
          var p = sw.getAttribute('data-bp-price') || '';
          if (priceEl && p) priceEl.textContent = p;
          sticky(p);
          setText(oldEl, sw.getAttribute('data-bp-old') || '');
          setAvail(bpOk);
          /* Bild: eigenes Bild der Bundle-Variante > Galerie je Option > Ersatzbild-Setting. */
          var bpImg = sw.getAttribute('data-bp-image');
          if (hero.__lp2ColorSlot) hero.__lp2OptGallery('b');
          else if (bpImg) swapMain(bpImg, sw.getAttribute('data-bp-srcset') || '');
          else if (!(hero.__lp2OptGallery && hero.__lp2OptGallery('b')) && FB_IMG) swapMain(FB_IMG, FB_SET);
        } else {
          if (!imgSwapped && hero.__lp2OptGallery) hero.__lp2OptGallery('a');
          if (idInput) idInput.value = sw.getAttribute('data-id') || idInput.value;
          var pa = sw.getAttribute('data-price') || '';
          if (priceEl && pa) priceEl.textContent = pa;
          sticky(pa);
          setText(oldEl, sw.getAttribute('data-old') || '');
          setAvail(sw.getAttribute('data-available') !== 'false');
        }
        /* F33/F34: Kachelbilder folgen der Farbe. Erst dekodieren (vorgeladen, s. preTile), dann
           BEIDE Kacheln gemeinsam setzen - max. 300 ms warten, damit nie etwas haengt. */
        swapTiles(sw);
        cplPicker();
        soAria();
        /* F21: Set-Feld der Sticky-Leiste spiegeln (Leiste haengt im Body-Portal) */
        var ssel = document.querySelector('[data-sticky-set-select]');
        if (ssel && ssel.value !== state) ssel.value = state;
        /* F18: Covers-only-Hinweis nur in A, in B ganz weg (Owner: "verschwinden") */
        var note = $('[data-bundle-note]', hero);
        if (note) note.hidden = state !== 'a';
        /* seitenweit: auch Sections ausserhalb der Hero (How it works) tragen data-opt-show */
        $$('[data-opt-show]').forEach(function (el) { el.hidden = el.getAttribute('data-opt-show') !== state; });
        if (incl && inclText) {
          var tb = incl.getAttribute('data-incl-b') || '';
          var useB = state === 'b' && !!tb;
          inclText.textContent = useB ? tb : (incl.getAttribute('data-incl-a') || '');
          if (inclNote) inclNote.hidden = useB;
        }
        syncUrl();
      }

      function setState(next) {
        var prev = state;
        state = next === 'b' ? 'b' : 'a';
        segs.forEach(function (b) {
          var on = b.getAttribute('data-bundle-seg') === state;
          b.classList.toggle('active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
        });
        hero.setAttribute('data-bundle-state', state);
        /* B -> A mit getauschtem Bild: die aktive Farbe erneut waehlen (selectTile malt Bild,
           Preis, ID des Bezugs); der riwi:lp2:variant-Hoerer unten ruft danach paint(). */
        var sw = activeSwatch();
        if (prev === 'b' && state === 'a' && imgSwapped && sw) { imgSwapped = false; sw.click(); return; }
        paint();
      }

      segs.forEach(function (b) {
        b.addEventListener('click', function () { setState(b.getAttribute('data-bundle-seg')); });
        b.addEventListener('keydown', function (e) {
          var d = 0;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') d = 1;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') d = -1;
          if (!d) return;
          e.preventDefault();
          var i = segs.indexOf(b);
          if (i < 0) i = 0;
          var n = segs[(i + d + segs.length) % segs.length];
          n.click();
          if (n.focus) n.focus();
        });
      });

      hero.addEventListener('riwi:lp2:variant', function () { imgSwapped = false; paint(); });
      /* F21: Set-Feld der Sticky-Leiste -> DIESELBE Kachel wie ein Klick in der Kaufbox. Die
         Referenz wird hier geholt, solange die Leiste noch in der Section haengt (das Portal
         verschiebt denselben Knoten). */
      var stickySet = $('[data-sticky-set-select]', hero) || document.querySelector('[data-sticky-set-select]');
      if (stickySet) {
        stickySet.addEventListener('change', function () {
          var t = $('[data-bundle-seg="' + (stickySet.value === 'b' ? 'b' : 'a') + '"]', root);
          if (t) t.click(); else stickySet.value = state;
        });
      }
      /* F27 (16.10.2026): Retargeting-Vorauswahl per URL. ?set=covers|couch waehlt die Option,
         ?color=<Optionswert> (Anfang genuegt, Gross/klein und Bindestriche egal) die Farbe -
         ein vorhandenes ?variant= hat fuer die Farbe Vorrang (Server-Render). Flackerfrei per
         Server-Render: /products/riwi-couch?view=riwi-lp2-couch-covers (Vorlage mit Start A). */
      try {
        var qp = new URLSearchParams(window.location.search);
        var nrm = function (x) { return (x || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); };
        var want = nrm(qp.get('color'));
        /* T4b: ?variant= darf eine Bezugs- ODER Bundle-ID sein (geteilte Links aus syncUrl). Der
           Server kennt nur IDs des Seitenprodukts - die Farbe wird hier nachgezogen, wenn sie nicht
           schon aktiv ist. Ohne ?set bestimmt der ID-Typ den Zustand (Bundle-ID -> Komplett; auf der
           Bundle-Seite Bezugs-ID -> Bezuege), ?set gewinnt immer. */
        var qv = (qp.get('variant') || '').replace(/[^0-9]/g, '');
        var vSet = '';
        if (qv) {
          var vHit = null;
          $$('[data-cv-swatch]', hero).forEach(function (b) {
            if (vHit) return;
            if (b.getAttribute('data-bp-id') === qv) { vHit = b; vSet = 'b'; }
            else if (b.getAttribute('data-id') === qv) { vHit = b; vSet = MIRROR ? 'a' : ''; }
          });
          if (vHit && !vHit.classList.contains('active')) vHit.click();
        }
        if (want && !qp.get('variant')) {
          var hit = null;
          $$('[data-cv-swatch]', hero).forEach(function (b) {
            var n = nrm(b.getAttribute('data-name'));
            if (!hit && (n === want || n.indexOf(want + ' ') === 0)) hit = b;
          });
          if (hit && !hit.classList.contains('active')) hit.click();
        }
        var setp = (qp.get('set') || '').toLowerCase();
        if (setp !== SET_A && setp !== SET_B) setp = vSet === 'a' ? SET_A : (vSet === 'b' ? SET_B : '');
        if (setp === SET_A && state !== 'a') setState('a');
        else if (setp === SET_B && state !== 'b') setState('b');
        /* T4b: kam der Zustand per URL, die Adresse einmal normalisieren (selectTile schreibt beim
           Nachziehen der Farbe sonst nur ?variant=); ohne Parameter bleibt sie unangetastet. */
        URL_ON = !!(qp.get('set') || qv);
      } catch (e) { /* alter Browser ohne URLSearchParams: Server-Startzustand bleibt */ }
      hero.setAttribute('data-bundle-state', state);
      /* Startzustand steht im Server-Render (Preis, Kachel, Form-ID). paint() gleicht nur ab
         (z. B. Farbe per ?variant= ohne Bundle-Variante) und tauscht ggf. das Galeriebild. */
      paint();
      URL_ON = true;
    })();

    /* Eingeklappte Farbgruppe (swatch_more_collapse): wird eine Farbe daraus gewaehlt (Pfeiltaste,
       Sticky-Dropdown, Bestandsfilter), klappt die Gruppe auf - nie eine unsichtbare Auswahl. */
    (function () {
      var hero = $('[data-riwi-lp2-hero]');
      if (!hero) return;
      var det = $('details[data-sw-more-details]', hero);
      if (!det) return;
      hero.addEventListener('riwi:lp2:variant', function () {
        var a = $('.variant.active', hero);
        if (a && det.contains(a) && !det.open) det.open = true;
      });
    })();

    (function () {
      var hero = $('[data-riwi-lp2-hero]');
      if (!hero) return;
      var root = $('[data-bundle-toggle]', hero);
      if (!root) return;
      /* Produkt-Umschalter hat sein eigenes Modul (direkt darueber). */
      if (root.getAttribute('data-bundle-mechanic') === 'product') return;
      var segs = $$('[data-bundle-seg]', root);
      if (segs.length < 2) return;

      var VID = parseInt(root.getAttribute('data-bundle-variant'), 10) || 0;
      var TPL = root.getAttribute('data-bundle-save-tpl') || '';
      /* P4 (09.10.2026): Startzustand aus dem Section-Setting bundle_default. Nur 'b' steht
         als Attribut im Markup; fehlt es, ist alles wie bisher (Startzustand A). */
      var START = root.getAttribute('data-bundle-default') === 'b' ? 'b' : 'a';
      var priceEl = $('[data-price]', hero);
      var oldEl = $('[data-old-price]', hero);
      var saveEl = $('[data-bundle-save]', hero);
      /* Typ-gescopter Selektor (Lektion 16.09.2026): [data-variant-id] traegt auch jedes
         Farbfeld - ohne input[...] traefe querySelector das Farbfeld statt des Formularfeldes. */
      var idInput = $('input[data-variant-id]', hero);
      /* FAM-4: Preise IN den Bild-Kacheln. In der Segment-Darstellung gibt es diese Knoten
         nicht - dann tut paintTiles() nichts. */
      var tilePriceA = $('[data-bundle-tile-price="a"]', root);
      var tilePriceB = $('[data-bundle-tile-price="b"]', root);

      /* Die EINE Zubehoer-Zeile, die Zustand B einhaengt: die mit genau dieser Set-Variante. */
      var row = null;
      $$('[data-addon][data-addon-variant]', hero).forEach(function (r) {
        if (!row && (parseInt(r.getAttribute('data-addon-variant'), 10) || 0) === VID) row = r;
      });
      var cb = row ? $('[data-addon-check]', row) : null;
      if (!row || !cb) {
        root.hidden = true;
        /* P4: Start in B ohne Zubehoer-Zeile = kein Kaufweg fuer das Set. Der Server hat den
           Bundle-Preis schon gemalt - zurueck auf die A-Anzeige, damit Preis und Warenkorb
           zusammenpassen (paintA ist eine hochgezogene Funktionsdeklaration). */
        if (START === 'b') { hero.setAttribute('data-bundle-state', 'a'); paintA(); }
        return;
      }
      row.setAttribute('data-bundle-managed', '');

      function parseMap(str) {
        var out = {};
        (str || '').split('|').forEach(function (pair) {
          if (!pair) return;
          var i = pair.indexOf(':');
          if (i < 1) return;
          out[pair.slice(0, i)] = pair.slice(i + 1);
        });
        return out;
      }
      function activeSwatch() { return $('.variant.active', hero); }
      /* Stueckzahl des Bezugs - dieselbe Zahl, die in den Warenkorb geht (Kaufform). */
      function anchorQty() {
        var qEl = idInput && idInput.form ? idInput.form.querySelector('[name="quantity"]') : null;
        var n = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
        return n < 1 ? 1 : n;
      }

      var state = 'a';
      var savedChecked = false, saved = false;

      function paintB() {
        var sw = activeSwatch();
        if (!sw) return;
        var n = String(anchorQty());
        var total = parseMap(sw.getAttribute('data-bundle-q'))[n];
        var old = parseMap(sw.getAttribute('data-bundle-old-q'))[n];
        if (total) {
          if (priceEl) priceEl.textContent = total;
          /* Die Leiste haengt im Body-Portal - dokumentweit suchen, wie ueberall sonst. */
          var st = document.querySelector('[data-sticky-price]');
          if (st) st.textContent = total;
        }
        if (oldEl) {
          /* Streichpreis nur, wenn er sich vom Bundle-Preis unterscheidet - sonst stuende
             derselbe Betrag zweimal da, einmal durchgestrichen. */
          var show = !!(old && total && old !== total);
          oldEl.textContent = show ? old : '';
          oldEl.hidden = !show;
        }
        if (saveEl) {
          var amt = parseMap(sw.getAttribute('data-bundle-save-q'))[n];
          var code = parseMap(sw.getAttribute('data-bundle-code-q'))[n];
          if (TPL && amt && code) {
            saveEl.textContent = TPL.replace('{amount}', amt).replace('{code}', code);
            saveEl.hidden = false;
          } else {
            saveEl.textContent = '';
            saveEl.hidden = true;
          }
        }
      }

      /* FAM-4: beide Kachelpreise gleichzeitig - die Kacheln zeigen immer BEIDE Optionen,
         unabhaengig davon, welche gerade gewaehlt ist. Gerechnet wird auch hier nichts: A
         kommt aus data-price-q (dieselbe Karte, die der Mengenwaehler liest), B aus
         data-bundle-q (dieselbe, die paintB liest). Eine Quelle je Zahl. */
      function paintTiles() {
        if (!tilePriceA && !tilePriceB) return;
        var sw = activeSwatch();
        if (!sw) return;
        var n = String(anchorQty());
        var a = parseMap(sw.getAttribute('data-price-q'))[n] || sw.getAttribute('data-price') || '';
        var b = parseMap(sw.getAttribute('data-bundle-q'))[n] || '';
        if (tilePriceA && a) tilePriceA.textContent = a;
        if (tilePriceB && b) tilePriceB.textContent = b;
      }

      /* Zurueck auf Zustand A = GENAU die Anzeige der uebrigen Module: Mengenwaehler-Summe,
         sonst der Farbpreis. Kein dritter Rechenweg. */
      function paintA() {
        var sw = activeSwatch();
        if (!sw) return;
        var total = parseMap(sw.getAttribute('data-price-q'))[String(anchorQty())]
          || sw.getAttribute('data-price') || '';
        if (total) {
          if (priceEl) priceEl.textContent = total;
          var st = document.querySelector('[data-sticky-price]');
          if (st) st.textContent = total;
        }
        if (oldEl) {
          var o = sw.getAttribute('data-old') || '';
          oldEl.textContent = o;
          oldEl.hidden = !o;
        }
        if (saveEl) { saveEl.textContent = ''; saveEl.hidden = true; }
      }

      function fire(el) {
        try { el.dispatchEvent(new Event('change', { bubbles: true })); }
        catch (e) {
          /* alter Browser: der Haken sitzt trotzdem, nur die Sichtbarkeits-Logik der
             Zubehoer-Zeile laeuft nicht mit - die Zeile ist in Zustand B ohnehin verborgen. */
        }
      }

      function setState(next) {
        state = next === 'b' ? 'b' : 'a';
        segs.forEach(function (b) {
          var on = b.getAttribute('data-bundle-seg') === state;
          b.classList.toggle('active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
        });
        hero.setAttribute('data-bundle-state', state);
        if (state === 'b') {
          if (!saved) { savedChecked = !!cb.checked; saved = true; }
          if (!cb.checked) { cb.checked = true; fire(cb); }
          paintB();
        } else {
          if (saved && cb.checked !== savedChecked) { cb.checked = savedChecked; fire(cb); }
          saved = false;
          paintA();
        }
        paintTiles();
      }

      segs.forEach(function (b) {
        b.addEventListener('click', function () { setState(b.getAttribute('data-bundle-seg')); });
        b.addEventListener('keydown', function (e) {
          var d = 0;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') d = 1;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') d = -1;
          if (!d) return;
          e.preventDefault();
          var i = segs.indexOf(b);
          if (i < 0) i = 0;
          var n = segs[(i + d + segs.length) % segs.length];
          n.click();
          if (n.focus) n.focus();
        });
      });

      /* Farb-/Stufen-/Mengenwechsel: in Zustand B die Bundle-Summe nachziehen. In Zustand A
         nicht eingreifen - dort sind selectTile() und der Mengenwaehler die Wahrheit. */
      hero.addEventListener('riwi:lp2:variant', function () { if (state === 'b') paintB(); paintTiles(); });

      /* Startzustand A steht schon im Server-Render (active/aria-checked im Markup) - hier
         wird NICHT neu gemalt, damit beim Laden kein Wert durch einen zweiten Weg entsteht.
         Nur das Zustands-Attribut fuer die CSS wird gesetzt. */
      if (START !== 'b') {
        hero.setAttribute('data-bundle-state', 'a');
      } else {
        /* P4: Startzustand B (bundle_default = b). Markup und Preise stehen schon im
           Server-Render; hier wird nur der Haken der Zubehoer-Zeile eingehaengt - mit
           DEMSELBEN setState('b') wie beim Klick, also derselbe Kaufweg (combinedAdd). Ein
           Kauf direkt nach dem Laden, ohne jede Interaktion, legt damit Bezug + Set ein.
           savedChecked merkt sich den ungesetzten Haken: zurueck auf A nimmt das Set wieder
           heraus. */
        setState('b');
        /* Wird die Zeile danach unwaehlbar (Bestandsfilter: Haken zurueck + disabled, oder
           vom Plan ausgeblendet), passt der B-Preis nicht mehr zum Warenkorb: dann sauber
           auf A und den Umschalter weg - kein toter Knopf. Der Bestandsfilter feuert sein
           Ereignis NACH diesem Modul; setTimeout laesst den Hoerer der Zubehoer-Zeile
           (assets/riwi-lp2-addons.js) zuerst arbeiten. */
        var guard = function () {
          if (!(cb.disabled || row.hidden || (state === 'b' && !cb.checked))) return;
          if (state === 'b') setState('a');
          if (cb.disabled || row.hidden) root.hidden = true;
        };
        hero.addEventListener('riwi:lp2:stock', function () { window.setTimeout(guard, 0); });
        hero.addEventListener('riwi:lp2:variant', function () { window.setTimeout(guard, 0); });
        /* Die Zubehoer-Zeile wendet beim eigenen Start (assets/riwi-lp2-addons.js laeuft NACH
           dieser Datei) ggf. Plan/Gratis-Regel an und nimmt den Haken still zurueck - ohne
           Ereignis. Deshalb einmal pruefen, wenn alle defer-Skripte gelaufen sind. */
        if (document.readyState === 'complete') window.setTimeout(guard, 0);
        else {
          document.addEventListener('DOMContentLoaded', function () { window.setTimeout(guard, 0); }, { once: true });
          window.addEventListener('load', guard, { once: true });
        }
      }
    })();

    /* -------------------------------------------------------------- A/B-Arm anwenden
       Letzter Schritt der Verdrahtung: JETZT haengen alle Spiegel (Sticky-Leiste, FREE12-Box,
       Store-Modal-Mapping) an riwi:lp2:variant, ein Variantenwechsel kommt also ueberall an.
       data-ab-pending (der Anti-Flacker-Deckel der CSS) wird IMMER entfernt - auch wenn die
       Arm-Kachel fehlt oder etwas wirft. Sonst bliebe die Buybox unsichtbar, bis der Timeout
       im Inline-Script der Section greift. */
    (function () {
      var hero = $('[data-riwi-lp2-hero]');
      if (!hero) return;
      try {
        if (hero.__lp2ApplyAbArm) hero.__lp2ApplyAbArm();
      } catch (e) { /* nie den Kaufpfad blockieren */ }
      hero.removeAttribute('data-ab-pending');
    })();

    /* ---------------------------------------------------------------------- A/B-Messung
       Drei Events, keine eigene Zeitmessung: die Verweildauer liefert GA4 selbst
       (engagement_time_msec je Pageview), segmentierbar ueber das Exposure-Event.
         lp2_ab_exposure      einmal je Pageview  { ab_arm, ab_default_blocks }
         lp2_ab_variant_click Nutzer wechselt das Set { ab_arm, from_blocks, to_blocks,
                              source: 'tile' | 'select' }
         lp2_ab_atc           Add-to-cart { ab_arm, blocks?, source: 'main' | 'sticky' |
                              'tile' | 'modal' | 'bundle' }
       Datensparsamkeit: nur Blockzahlen und der Arm-Buchstabe, keine Personendaten, kein
       eigenes Cookie, keine eigene Netzverbindung - alles laeuft ueber das bestehende
       Google-Tag der Storefront (Consent inklusive, siehe send() unten).
       Alle Aufrufe sind fire-and-forget in try/catch und laufen am document in der
       CAPTURE-Phase: sie duerfen den Kaufpfad weder verzoegern noch abbrechen und rufen
       niemals preventDefault().
       Ist der Test aus, fehlt data-ab-active -> das Modul beendet sich sofort. */
    (function () {
      var hero = $('[data-riwi-lp2-hero]');
      if (!hero || hero.getAttribute('data-ab-active') !== '1') return;
      var ARM = hero.getAttribute('data-ab-arm') || '';
      var ARM_BLOCKS = parseInt(hero.getAttribute('data-ab-blocks'), 10) || 0;
      if (!ARM || !ARM_BLOCKS) return;      /* Zuteilung nicht gelaufen -> nicht messen */

      /* Senke ist das Google-Tag (gtag). WICHTIGE FALLE, am Live-Shop nachgemessen
         (04.09.2026, tools/cdp_ab_arm_probe.py bzw. das Timing-Protokoll dazu):
         zum DOMContentLoaded - also genau dann, wenn dieses Modul laeuft - ist window.gtag
         auf BEIDEN Shops noch UNDEFINIERT. Die Google-&-YouTube-App der Storefront injiziert
         gtag.js erst danach (.com ~70 ms, .us ~190 ms nach DCL; auch window.dataLayer
         entsteht erst dann). Im ausgelieferten HTML ist davon nichts zu sehen - wer nur die
         Quelle liest, haelt den Shop faelschlich fuer GA4-frei.
         Eine reine `typeof gtag === "function"`-Pruefung wuerde deshalb das Exposure-Ereignis
         still verschlucken - genau das Ereignis, an dem die ganze Auswertung haengt.
         Loesung ist der Standard-Kniff von Google: fehlt gtag, legen wir die uebliche Weiche
         selbst an (dataLayer + gtag-Shim). gtag.js arbeitet die Warteschlange beim Laden ab.
         Beide Shops nutzen den Standardnamen `dataLayer` (nachgesehen: 12 bzw. 11 Eintraege).
         Laedt gtag.js nie (keine Zustimmung), bleiben die Ereignisse in der Warteschlange
         liegen: kein Netzverkehr, keine Messung - genau das richtige Verhalten.
         Ohne send_to gehen die Ereignisse an alle konfigurierten Ziele (GA4 UND Google Ads);
         fuer Ads sind unbekannte Ereignisnamen wirkungslos. */
      function send(name, params) {
        try {
          window.riwiAnalyticsOk(function () {
          params = params || {};
          params.ab_arm = ARM;
          if (typeof window.gtag !== 'function') {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function () { window.dataLayer.push(arguments); };
          }
          window.gtag('event', name, params);
          });
        } catch (e) { /* Messung darf nie stoeren */ }
      }

      var tiles = $$('.variant', hero);
      function blocksOf(el) {
        return el ? (parseInt(el.getAttribute('data-blocks'), 10) || 0) : 0;
      }
      function activeBlocks() { return blocksOf($('.variant.active', hero)); }
      /* Varianten-ID -> Blockzahl ueber die Kacheln (die einzige Stelle, die beides kennt).
         Damit brauchen Store-Modal, Bundle und die Set-Karten keine eigene Blockzahl. */
      function blocksForId(id) {
        var hit = 0;
        id = (id === 0 || id) ? String(id) : '';
        if (!id) return 0;
        tiles.forEach(function (x) { if (!hit && x.getAttribute('data-id') === id) hit = blocksOf(x); });
        return hit;
      }
      function valOf(sel, root) {
        var el = $(sel, root || document);
        return el ? el.value : '';
      }

      /* 1) Exposure - einmal je Pageview, direkt nach der Arm-Anwendung.
            Bewusst NICHT erneut bei pageshow/bfcache: eine Rueckkehr per Zurueck-Button ist
            kein neuer Seitenaufruf und wuerde den Arm doppelt zaehlen. */
      send('lp2_ab_exposure', { ab_default_blocks: ARM_BLOCKS });

      /* 2) Variantenwechsel + 3) Add-to-cart, ein Listener am document (capture).
            capture am document laeuft VOR selectTile() und vor den FREE12-Hooks: die aktive
            Kachel ist also noch die alte -> from_blocks stimmt. */
      var ATC_SOURCES = [
        ['[data-atc]', 'main'],
        ['[data-sticky-btn]', 'sticky'],
        ['[data-f12-set-form]', 'tile'],
        ['.set-card form', 'tile'],
        ['[data-sm-submit]', 'modal'],
        ['[data-bm-submit]', 'bundle']
      ];
      document.addEventListener('click', function (e) {
        try {
          var el = e.target;
          if (!el || !el.closest) return;

          /* Set-Kachel der Buybox = echter Nutzer-Variantenwechsel. */
          var t = el.closest('.variant');
          if (t && hero.contains(t)) {
            var from = activeBlocks(), to = blocksOf(t);
            if (to && from !== to) {
              send('lp2_ab_variant_click', { from_blocks: from, to_blocks: to, source: 'tile' });
            }
            return;
          }

          var src = '', node = null;
          for (var i = 0; i < ATC_SOURCES.length; i++) {
            node = el.closest(ATC_SOURCES[i][0]);
            if (node) { src = ATC_SOURCES[i][1]; break; }
          }
          if (!src) return;
          /* Blockzahl aus der Varianten-ID des jeweiligen Kaufpfads; laesst sie sich nicht
             bestimmen, wird der Parameter WEGGELASSEN statt eine 0 zu melden. */
          var b = 0;
          if (src === 'tile') {
            b = parseInt(node.getAttribute && node.getAttribute('data-f12-blocks'), 10) || 0;
            if (!b) b = blocksForId(valOf('input[name="id"]', node));
          } else if (src === 'modal') {
            b = blocksForId(valOf('[data-sm-set-input]'));
          } else if (src === 'bundle') {
            var bForm = node.closest ? node.closest('form') : null;
            b = blocksForId(valOf('input[name="items[0][id]"]', bForm));
          } else {
            b = blocksForId(valOf('input[data-variant-id]', hero));
          }
          var p = { source: src };
          if (b) p.blocks = b;
          send('lp2_ab_atc', p);
        } catch (err) { /* Messung darf nie stoeren */ }
      }, true);

      /* Set-Dropdown der Sticky-Leiste. Der Listener haengt am document (capture), NICHT am
         select: am select selbst liefe der bestehende change-Handler zuerst (frueher
         registriert) und haette selectTile() schon aufgerufen - from_blocks waere dann
         bereits der neue Wert. */
      document.addEventListener('change', function (e) {
        try {
          var el = e.target;
          if (!el || !el.matches || !el.matches('[data-sticky-select]')) return;
          var from = activeBlocks(), to = blocksForId(el.value);
          if (!to || from === to) return;
          send('lp2_ab_variant_click', { from_blocks: from, to_blocks: to, source: 'select' });
        } catch (err) { /* Messung darf nie stoeren */ }
      }, true);
    })();

    /* --------------------------------------- F53b: mengenbewusster Bestandsfilter (Owner 15.09.2026)
       Ebenfalls nach assets/riwi-lp2-addons.js umgezogen (s. o.) — er gehoert zum Add-on-Block
       und muss im Warenkorb genauso laufen. Er laeuft dort als LETZTES, weil er riwi:lp2:stock
       FEUERT und die Hoerer (u. a. der Gratis-Bag-Picker hier in dieser Datei) vorher stehen
       muessen; bei einem sessionStorage-Treffer laeuft er synchron. */

    /* -------------------------------------------- Sektions-/Klick-Metriken (GA4)
       Unabhaengig vom A/B-Test (KEIN data-ab-active-Gate) - laeuft nach Testende weiter,
       ab_arm ist dann leer. Alles fire-and-forget in try/catch, nie preventDefault/
       stopPropagation, keine Layoutwirkung.
         lp2_section_view  { section, position, ab_arm, lp }  1x je Sektion je Pageview
         lp2_click         { section, element, ab_arm, lp }   Klick/Tap bzw. Select-change
         lp2_section_dwell { section, seconds_bucket, ab_arm, lp }  hinter DWELL, AUS
       Marker: data-lp2-section am Sektions-Wrapper, data-lp2-track am Element. Portal-
       Knoten (Sticky-Leiste, Store-/Bundle-Modal) haengen am <body> und tragen
       data-lp2-section deshalb SELBST; :not([data-lp2-track]) haelt sie aus der
       Sektionsliste heraus, sonst zaehlte position doppelt. */
    (function () {
      var DWELL = false;
      var secs = $$('[data-lp2-section]:not([data-lp2-track])');
      if (!secs.length) return;
      var h = $('[data-riwi-lp2-hero]'), ARM = (h && h.getAttribute('data-ab-arm')) || '';
      /* Shop UND Seitentyp: dieselben LP2-Sections rendern seit 09/2026 auch die Produktseite
         /products/riwi-building-blocks. Ohne das Suffix liefen Landingpage und Produktseite in
         EINEN GA4-Bericht und jede Vorher/Nachher-Messung waere wertlos. */
      var LP = (/\.us$/.test(location.hostname) ? 'us' : 'com') +
               (/\/products\//.test(location.pathname) ? '-pdp' : '');
      /* section.id rendert in JSON-Templates als 'template--<id>__<key>' -> nur den Key hinter dem letzten '__' senden. */
      function nm(el) { var v = (el && el.getAttribute('data-lp2-section')) || ''; return v.split('__').pop(); }
      secs.forEach(function (el, i) { el.__lp2p = i + 1; if (DWELL) el.__lp2ms = 0; });

      /* gtag ist zum DOMContentLoaded noch UNDEFINIERT (gtag.js kommt erst danach) - eine
         reine typeof-Pruefung verschluckte die fruehen Ereignisse still. Daher dataLayer-
         Shim, exakt wie in der A/B-Messung oben. */
      function send(name, p) {
        try {
          window.riwiAnalyticsOk(function () {
          p.ab_arm = ARM; p.lp = LP;
          if (typeof window.gtag !== 'function') {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function () { window.dataLayer.push(arguments); };
          }
          window.gtag('event', name, p);
          });
        } catch (e) { /* Messung darf nie stoeren */ }
      }

      /* Sichtbar = ratio >= .5 ODER - bei Sektionen, die hoeher sind als der Viewport und
         ratio .5 nie erreichen koennen (Hero mobil) - sichtbarer Teil >= 50 % der
         Viewporthoehe. Mehrere Thresholds, weil eine einzelne .5-Schwelle bei hohen
         Sektionen nie ueberschritten wird und der Observer dann nicht mehr nachfeuert.
         __lp2s wird nie zurueckgesetzt: eine Rueckkehr per Zurueck-Button (pageshow/bfcache)
         ist kein neuer Seitenaufruf und darf nicht doppelt zaehlen. */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          var vh = window.innerHeight || 0, now = Date.now();
          es.forEach(function (el2) {
            var el = el2.target, r = el2.intersectionRect;
            var vis = el2.isIntersecting && (el2.intersectionRatio >= .5 || (vh && r.height >= vh * .5));
            if (DWELL && el.__lp2t0) { el.__lp2ms += now - el.__lp2t0; el.__lp2t0 = 0; }
            if (!vis) { if (el.__lp2tm) { clearTimeout(el.__lp2tm); el.__lp2tm = 0; } return; }
            if (DWELL) el.__lp2t0 = now;
            if (el.__lp2s || el.__lp2tm) return;
            el.__lp2tm = setTimeout(function () {
              el.__lp2tm = 0; el.__lp2s = 1;
              send('lp2_section_view', { section: nm(el), position: el.__lp2p });
            }, 1000);
          });
        }, { threshold: [0, .05, .1, .2, .35, .5] });
        secs.forEach(function (el) { io.observe(el); });
      }

      /* Delegation am document, passiv, nie preventDefault/stopPropagation. section =
         naechster Vorfahre mit data-lp2-section; bei Portal-Knoten (Sticky, Store-/Bundle-
         Modal) trifft closest() das Element selbst. Arbeitsteilung der beiden Klick-Delegate:
           mode 0   CAPTURE-Klick: alles ausser Galerie und <select>.
           mode 2   change: nur <select> (sticky_select) - der Klick darauf zaehlt nicht.
           mode 1   BUBBLE-Klick, NUR hero_gallery_open: das Galerie-JS schluckt einen Wisch per
                    stopImmediatePropagation, in der Bubble-Phase erreicht uns deshalb nur
                    der echte Oeffnen-Klick - ein Wisch zaehlt nicht mit.
         Videos bekommen bewusst KEIN play-Ereignis: die Review-Clips starten stumm per
         IntersectionObserver (Autoplay), das waere kein Nutzersignal. Gezaehlt wird der
         Klick/Tap auf die Kachel (review_video_N). Modal-Backdrops tragen keinen Marker,
         nur der ausdrueckliche Schliessen-Knopf. */
      var GAL = 'hero_gallery_open';
      function hit(el, mode) {
        try {
          var t = el && el.closest ? el.closest('[data-lp2-track]') : null;
          if (!t) return;
          var k = t.getAttribute('data-lp2-track'), sel = t.tagName === 'SELECT';
          if (mode === 1 ? k !== GAL : mode ? !sel : (k === GAL || sel)) return;
          send('lp2_click', { section: nm(t.closest('[data-lp2-section]')), element: k });
        } catch (err) { /* Messung darf nie stoeren */ }
      }
      var OPT = { capture: true, passive: true };
      document.addEventListener('click', function (e) { hit(e.target, 0); }, OPT);
      document.addEventListener('click', function (e) { hit(e.target, 1); }, { passive: true });
      document.addEventListener('change', function (e) { hit(e.target, 2); }, OPT);

      /* Verweildauer je Sektion - gebaut, aber AUS (DWELL=false). */
      if (DWELL) window.addEventListener('pagehide', function () {
        try {
          var now = Date.now();
          secs.forEach(function (el) {
            if (el.__lp2t0) { el.__lp2ms += now - el.__lp2t0; el.__lp2t0 = 0; }
            var s = el.__lp2ms / 1000;
            if (s) send('lp2_section_dwell', { section: nm(el), seconds_bucket: s < 3 ? '0-3' : s < 10 ? '3-10' : s < 30 ? '10-30' : '30+' });
          });
        } catch (err) { /* Messung darf nie stoeren */ }
      });
    })();

    /* ------------------------------------------- N2 (16.09.2026): Drawer fuer den NACKTEN ATC
       Befund aus der CDP-Reproduktion auf der Couch-PDP (`?view=riwi-lp2-couch`, mobil 390):
       kein Zubehoer-Haken, keine FREE12-/FREEBAG-Box, keine Mengenstaffel -> KEIN Modul greift,
       der Klick laeuft ins native Formular: `POST /cart/add` (Typ Document) -> `GET /cart`.
       Auf diesem Weg konnte der Drawer nie aufgehen, weil gar kein JS beteiligt war.

       Dawns <product-form>-Weg (Hero-Setting `enable_cart_drawer`) ist hier KEINE Loesung:
       assets/product-form.js greift in onSubmitHandler blind auf `.loading__spinner` zu
       (`this.querySelector('.loading__spinner').classList.remove('hidden')`) - das Element
       gibt es in der LP2-Kaufform nicht, der Handler wuerde nach preventDefault werfen und der
       ATC waere tot. Deshalb faengt die LP2 den nackten Fall selbst ab.

       Dieses Modul ist bewusst das LETZTE: alle Kaufpfad-Module oben registrieren ihren
       Capture-Handler frueher und stoppen bei Zustaendigkeit per stopImmediatePropagation -
       dann kommt dieser hier nie dran. Und es ist an window.RiwiCartDrawerEnabled gebunden:
       ohne Drawer passiert NICHTS (natives Formular wie bisher, Verhalten unveraendert). */
    (function () {
      var hero = $('[data-riwi-lp2-hero]');
      if (!hero) return;
      var busy = false;

      function errorBox(form) {
        return form ? $('.product-form__error-message-wrapper', form) : null;
      }
      function showError(form, msg) {
        var wrap = errorBox(form);
        if (!wrap) return;
        var span = $('.product-form__error-message', wrap);
        if (span) span.textContent = msg;
        wrap.hidden = false;
      }
      function clearError(form) {
        var wrap = errorBox(form);
        if (!wrap) return;
        wrap.hidden = true;
        var span = $('.product-form__error-message', wrap);
        if (span) span.textContent = '';
      }

      function plainAdd(btn, form) {
        if (busy) return;
        /* Typ-gescopter Selektor (Lektion 16.09.2026): [data-variant-id] traegt auch der
           Farb-Swatch - ohne input[...] traefe querySelector den Swatch statt des Feldes. */
        var idInput = $('input[data-variant-id]', form) || form.querySelector('input[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        var id = idInput ? parseInt(idInput.value, 10) : 0;
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        if (!id) return;
        busy = true;
        clearError(form);
        var wasDisabled = btn.disabled;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        var release = function () { busy = false; btn.disabled = wasDisabled; btn.removeAttribute('aria-busy'); };
        Cart.addAndApply({
          tag: 'riwi-lp2 plain-atc',
          items: [{ id: id, quantity: qty > 0 ? qty : 1 }],
          codes: [],
          onError: function (msg) { release(); showError(form, msg); },
          onSuccess: release
        });
      }

      function hook(btn) {
        if (!btn || btn.__plainHooked) return;
        btn.__plainHooked = true;
        btn.addEventListener('click', function (e) {
          /* F2 (17.09.2026): Das Zubehoer-Modul liegt jetzt in assets/riwi-lp2-addons.js und
             wird SPAETER geladen - es registriert seinen Capture-Handler also NACH diesem hier.
             Die alte Zusicherung "dieses Modul ist das letzte" traegt sich damit nicht mehr von
             selbst, und ohne die Zeile hier schluckte dieser Handler den Klick, bevor das
             Zubehoer drankommt (am Staging mit CDP gemessen: add.js nur mit dem Set, kein
             STORE20). Deshalb dieselbe ausdrueckliche Nachfrage, die FREE12 und FREEBAG schon
             stellen - nur mit der vollen Zustaendigkeitsfrage (Haken ODER Mengenstaffel-Code),
             weil dieses Modul sonst den Staffel-Fall der Bag-Seite an sich zoege. */
          if (window.RiwiLp2Addons && window.RiwiLp2Addons.handles
              && window.RiwiLp2Addons.handles()) return;
          /* Ohne Drawer lief hier frueher das native Formular (POST /cart/add -> /cart).
             Button-System v2 (Owner 30.09.2026): Buttons mit data-rb-atc gehen denselben
             add.js-Weg wie mit Drawer, damit der Button Laden -> "Added" zeigen kann; das Ziel
             bleibt /cart (goToCartOrOpenDrawer). Ohne data-rb-atc: Verhalten unveraendert. */
          if (!window.RiwiCartDrawerEnabled && !btn.hasAttribute('data-rb-atc')) return;
          /* Ohne fetch NICHT abfangen - dann legt wenigstens das native Formular ab. */
          if (typeof window.fetch !== 'function') return;
          var form = btn.form;
          if (!form) return;
          if (busy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
          e.preventDefault();
          e.stopImmediatePropagation();
          plainAdd(btn, form);
        }, true);
      }
      hook($('[data-atc]', hero));
      hook($('[data-sticky-btn]'));

      /* Erfolgspfad mit Drawer navigiert nicht; ohne Drawer greift derselbe bfcache-Schutz
         wie in den anderen Modulen (eingefrorenes busy/disabled nach ZURUECK). */
      window.addEventListener('pageshow', function () {
        busy = false;
        $$('[data-atc], [data-sticky-btn]').forEach(function (b) {
          if (b && b.getAttribute('aria-busy') === 'true') {
            b.disabled = false;
            b.removeAttribute('aria-busy');
          }
        });
      });
    })();

    /* ------------------------------ Button-System v2 (Owner 30.09.2026): Set-Karten ohne Zugabe
       Karten MIT Zugabe uebernimmt das F37-Modul oben (preventDefault im submit). Die uebrigen
       Karten (z. B. 12er) posteten nackt auf /cart/add - dort gaebe es keine Antwort, auf die
       der Button "Added" zeigen koennte. Sie laufen jetzt ueber denselben Cart.addAndApply-Weg
       (Set allein, keine Codes) und landen genauso auf /cart. Nur Formulare mit exakt id +
       quantity werden uebernommen - alles andere (Properties, Zusatzfelder) bleibt nativ.
       Registriert NACH dem F37-Modul -> dessen submit-Handler laeuft zuerst. */
    (function () {
      if (typeof window.fetch !== 'function') return;
      var btns = $$('.set-card form [data-rb-atc]');
      if (!btns.length) return;
      var busy = false;
      var OK = { id: 1, quantity: 1, form_type: 1, utf8: 1 };
      function plainForm(form) {
        var els = form.elements;
        for (var i = 0; i < els.length; i++) {
          var el = els[i];
          if (!el.name || el.disabled || el.type === 'submit' || el.tagName === 'BUTTON') continue;
          if (!OK[el.name]) return false;
        }
        return true;
      }
      btns.forEach(function (btn) {
        var form = btn.form;
        if (!form || form.__rbPlain) return;
        form.__rbPlain = true;
        form.addEventListener('submit', function (e) {
          if (e.defaultPrevented) return;
          if (!plainForm(form)) return;
          var idInput = form.querySelector('input[name="id"]');
          var qtyInput = form.querySelector('input[name="quantity"]');
          var id = idInput ? parseInt(idInput.value, 10) : 0;
          var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
          if (!id) return;
          e.preventDefault();
          if (busy) return;
          busy = true;
          var err = $('[data-set-err]', form.parentNode || document);
          if (err) { err.hidden = true; err.textContent = ''; }
          var wasDisabled = btn.disabled;
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
          var release = function () { busy = false; btn.disabled = wasDisabled; btn.removeAttribute('aria-busy'); };
          Cart.addAndApply({
            tag: 'riwi-lp2 sets plain',
            items: [{ id: id, quantity: qty > 0 ? qty : 1 }],
            codes: [],
            onError: function (msg) {
              release();
              if (err) { err.textContent = msg; err.hidden = false; }
            },
            onSuccess: release
          });
        });
      });
      window.addEventListener('pageshow', function () { busy = false; });
    })();

    /* Button-System v2: bfcache-Rueckkehr (ZURUECK aus /cart) -> "Added"-Zustand und die
       eingefrorene Breite wieder loesen. busy/disabled setzen die Module oben selbst zurueck. */
    window.addEventListener('pageshow', function () {
      $$('[data-rb-atc]').forEach(function (b) {
        b.classList.remove('is-done');
        b.style.width = '';
        if (b.getAttribute('aria-busy') === 'true') {
          b.disabled = false;
          b.removeAttribute('aria-busy');
        }
      });
    });
  });
})();
